import React, {
	useState,
	useEffect,
	useRef,
	useContext,
	useCallback,
} from "react";
import "./css/KOT.css";
import Swal from "sweetalert2";
import tableImg from "./images/icons/tableee.png";
import P from "./p.json";
import Section from "./Section.json";
import Cross2 from "./images/icons/cross.png";
import Cross from "./images/icons/cross2.png";
import Cross1 from "./images/icons/delete.png";
import GroupD from "./images/icons/Groups.png";
import split from "./images/icons/split.png";
import merge from "./images/icons/merge.png";
import ss from "./images/login/ss_Logo.png";
import UserD from "./images/icons/User.png";
import Roundtable from "./images/icons/Round table.png";
import Minus from "./images/icons/minus.png";
import dot from "./images/icons/dot.png";
import rMinus from "./images/icons/minus (2).png";
import left from "./images/icons/back.png";
import right from "./images/icons/right-arrow.png";
import Plus from "./images/icons/plus.png";
import comment from "./images/icons/comment.png";
import save from "./images/icons/save.png";
import tick from "./images/icons/check.png";
import cross from "./images/icons/cross.png";
import Up from "./images/icons/up.png";
import Down from "./images/icons/down.png";
import Search from "./images/icons/search.png";
import search1 from "./images/MenuReg/search1.png";
import NavImg from "./images/icons/nav.png";
import Rupee from "./images/icons/rupee.png";
import info from "./images/icons/info.png";
import close from "./images/Inventory/close.png";
import remove from "./images/Inventory/delete.png";
import Veg from "./images/icons/veg.png";
import NonVeg from "./images/icons/nonVeg.png";
import MobileVeg from "./images/Mobile/veg.png";
import nonVeg from "./images/Mobile/nonVeg.png";
import NavBarMobile from "./Mobile/NavBar";
import MenuFooterMobile from "./Mobile/MenuFooter";
import CutleryInItems from "./images/Mobile/CutleryInItems.png";
import CustomerInfoMobile from "./Mobile/CustomerInfo";
import MobileKOTItems from "./js/mobileKOTitems.json";
import ClickItemWindow from "./Mobile/ClickItemWindow";
import cb from "./images/power.png";
import Lottie from "lottie-react";
import ActiveOrder from "./images/lotties/ActiveOrder3.json";
import SideNav from "./SideNav";
import TopRootDiv from "./TopRootDiv";
import SherDineNav from "./SherDineNav";
import VariantCountKOT from "./VariantCountKOT";
import axios from "axios";
import noImage from "./images/icons/depositphotos_247872612-stock-illustration-no-image-available-icon-vector.jpg";
import io from "socket.io-client";
import { DBContext } from "./DBContext";
import { useLocation, useNavigate } from "react-router-dom";
import { DineContext } from "./DineContext";
import { ToastContainer, toast } from "react-toastify";
import PrintBill from "./PrintBill";
import PartPay from "./PartPay";
import SplitBillModal from "./SplitBillModal";

function KOT() {
	const location = useLocation(null);
	const navigate = useNavigate(null);
	const [for_, setFor_] = useState(null);
	const [table_, setTable_] = useState(null);
	const [area_, setArea_] = useState(null);
	const [area_id_, setArea_id_] = useState(null);
	const [tableNo_, setTableNo_] = useState(null);
	const [areaCode, setAreaCode] = useState(null);
	// console.log(for_,'for_');
	const [DineType, setDineType] = useState(null);
	const [areaCode_, setAreaCode_] = useState(null);
	const [persons_, setPersons_] = useState(null);
	const [tableName_, setTableName_] = useState(null);

	const [totalPersons_, setTotalPersons_] = useState();

	// console.log(table_, "table_");

	const handleSetLoc = (state) => {
		setArea_(state.area);
		setArea_id_(state.area_id);
		setAreaCode_(state.areaCode);
		setFor_(state.for);

		setPersons_(state.persons);
		setTable_(state.table);
		setDineType(state.table || state.for);
		setTableNo_(state.tableNo);

		setTotalPersons_(state.persons);
		setTableName_(state.tableName);
		if (state.billNo) {
			setBillNo(state.billNo);
		} else {
			setBillNo(null);
		}
	};

	useEffect(() => {
		if (location.state) {
			// console.log(location.state, "state", location.state.table)
			handleSetLoc(location.state);
		}
	}, [location]);

	const toggleVisibility = () => {
		setIsVisible((prevState) => !prevState);
		// setTotalValue(total.toFixed(2));
	};

	const handleDineIn = () => {
		if (for_) {
			if (for_ === "delivery" || for_ === "pickup" || for_ === "parcel" || for_ === "reserve") {
				navigate("/TableView");
			}
		}
	};
	//latest 12-12-24
	const api_base_url = process.env.REACT_APP_API_BASE_URL;

	const { logginedDB, customerCode, hasPermission = () => true } = useContext(DBContext);

	const {
		alreadySelectedVariants,
		clearLoadOrder,
		previewPreviousOrders,
		previousOrders,
		setAlreadySelectedVariants,
		setPreviewPreviousOrders,
		setClearLoadOrderFunc,
		setPreviousOrders,
		setPreviousOrdersFunc,
	} = useContext(DineContext);
	const [noProductsMessage, setNoProductsMessage] = useState(false); // Tracks if "No items" message should show
	const [Database, setDatabase] = useState(localStorage.getItem("DB"));
	const [imgCode, setImgCode] = useState(localStorage.getItem("imgCode"));
	const [company, setCompany] = useState(localStorage.getItem("Company"));
	// const userType = localStorage.setItem('userType', JSON.stringify('Admin'));
	const userType = JSON.parse(localStorage.getItem("userType"));

	// console.log(userType, "kot");

	const [processedProducts, setProcessedProducts] = useState([]);
	const [selectedItems, setSelectedItems] = useState([]);

	const handleReset = () => {
		if (!clearLoadOrder) {
			setHoldInfo({});
			setHoldLoadOrderFunc(null);
			setSelectedItems([]);
			setAlreadySelectedVariants([]);
			setHoldInfo({});
		}
		if (selectedItems.length === 0) {
			setAlreadySelectedVariants([]);
		}
	};

	const [paymentMethod, setPaymentMethod] = useState(false);

	useEffect(() => {
		if (
			for_ === "delivery" ||
			for_ === "pickup" ||
			for_ === "parcel" ||
			(selectedItems.length === 0 && previousOrders.length > 0)
		) {
			setPaymentMethod(true);
		} else {
			setPaymentMethod(false);
		}
	}, [for_, selectedItems, previousOrders]);

	// useEffect(() => {
	//     handleReset()
	// },[selectedItems,clearLoadOrder])

	const [isVisible, setIsVisible] = useState(false);
	const [count, setCount] = useState({});
	const [inputValueDeliveryCharge, setInputValueDeliveryCharge] = useState(0);
	const [inputValueContainerCharge, setInputValueContainerCharge] = useState(0);
	const [inputValueCustomerPaid, setInputValueCustomerPaid] = useState(0);
	const [inputValueTip, setInputValueTip] = useState("");
	const [totalValue, setTotalValue] = useState("");
	const [addedBillTotal, setAddedBillTotal] = useState(null);
	const [addedBillAdjustments, setAddedBillAdjustments] = useState(null);
	const [isBillAmountAdded, setIsBillAmountAdded] = useState(false);
	const [discount, setDiscount] = useState(0); // percentage
	const [discountAmt, setDiscountAmt] = useState(0); // amount
	const [isComplimentary, setIsComplimentary] = useState(false);
	const [splitBillState, setSplitBillState] = useState(false);

	// Moved from below to fix TDZ ReferenceError
	const [total, setTotal] = useState(0);
	const [prevOrderTotal, setPrevOrderTotal] = useState(0);
	const [previousSelectedItems, setPreviousSelectedItems] = useState([]);
	const [previousSelectedItemsToBill, setPreviousSelectedItemsToBill] = useState([]);
	const [toIncludeAddonsToPrint, setToIncludeAddonsToPrint] = useState([]);
	const divRef = useRef(null);
	const [activeSection, setActiveSection] = useState("");
	const [dateTime, setDateTime] = useState(new Date());
	const [selectCount, setSelectCount] = useState(false);
	const [categories, setCategories] = useState([]);
	const [filteredProducts, setFilteredProducts] = useState([]);

	const [productionMap, setProductionMap] = useState({});
	const [prodSettings, setProdSettings] = useState({
		enable_production_tracking: '1',
		exempt_categories: '',
		exempt_items: ''
	});

	const fetchProductionStatus = useCallback(async () => {
		if (!logginedDB) return;
		try {
			const [prodRes, settingsRes] = await Promise.all([
				axios.get(`${api_base_url}/production/today/${logginedDB}`),
				axios.get(`${api_base_url}/production/settings/${logginedDB}`)
			]);

			if (prodRes.data && prodRes.data.success) {
				const pMap = {};
				prodRes.data.data.forEach(item => {
					if (item.variant_id) {
						pMap[`${item.item_id}_${item.variant_id}`] = item;
					} else {
						pMap[item.item_id] = item;
					}
				});
				setProductionMap(pMap);
			}

			if (settingsRes.data && settingsRes.data.success) {
				setProdSettings(settingsRes.data.settings || {});
			}
		} catch (error) {
			console.error("Error fetching daily production status or settings:", error);
		}
	}, [api_base_url, logginedDB]);

	const getProductTrackingInfo = useCallback((product) => {
		if (!product) return { isTracked: false, isSoldOut: false, isLowStock: false, available_qty: Infinity };

		if (prodSettings.enable_production_tracking === '0') {
			return { isTracked: false, isSoldOut: false, isLowStock: false, available_qty: Infinity };
		}

		if (prodSettings.exempt_categories && product.category) {
			const exemptCategories = prodSettings.exempt_categories.split(',').filter(Boolean);
			if (exemptCategories.includes(product.category)) {
				return { isTracked: false, isSoldOut: false, isLowStock: false, available_qty: Infinity };
			}
		}

		if (prodSettings.exempt_items) {
			const exemptItems = prodSettings.exempt_items.split(',').filter(Boolean);
			if (exemptItems.includes(String(product.id_productReg))) {
				return { isTracked: false, isSoldOut: false, isLowStock: false, available_qty: Infinity };
			}
		}

		const targetPoolId = product.production_link_item_id || product.id_productReg;
		const prodInfo = productionMap[targetPoolId];
		if (!prodInfo || prodInfo.is_active === 0 || prodInfo.is_active === false) {
			return { isTracked: true, isSoldOut: true, isLowStock: false, available_qty: 0 };
		}

		const isSoldOut = parseFloat(prodInfo.available_qty) <= 0;
		const isLowStock = !isSoldOut && parseFloat(prodInfo.available_qty) <= parseFloat(prodInfo.low_threshold);

		return {
			isTracked: true,
			isSoldOut,
			isLowStock,
			available_qty: parseFloat(prodInfo.available_qty),
			low_threshold: parseFloat(prodInfo.low_threshold)
		};
	}, [productionMap, prodSettings]);

	const getRemainingStock = (productId) => {
		const product = products.find(p => p.id_productReg === productId);
		const tracking = getProductTrackingInfo(product);

		if (!tracking.isTracked) {
			return Infinity;
		}

		if (tracking.isSoldOut) {
			return 0;
		}

		const targetPoolId = product.production_link_item_id || product.id_productReg;

		const selectedQty = selectedItems
			.reduce((sum, item) => {
				const itemProduct = products.find(p => p.id_productReg === item.productId);
				if (!itemProduct) return sum;

				const itemPoolId = itemProduct.production_link_item_id || itemProduct.id_productReg;
				if (itemPoolId !== targetPoolId) return sum;

				let factor = 1.0;
				if (item.varientId && itemProduct.varients) {
					const variant = itemProduct.varients.find(v => String(v.variantId) === String(item.varientId));
					if (variant && variant.deductionFactor !== undefined && variant.deductionFactor !== null) {
						factor = parseFloat(variant.deductionFactor);
					}
				}
				return sum + ((item.quantity || 0) * factor);
			}, 0);

		return tracking.available_qty - selectedQty;
	};

	// console.log('filteredProducts',filteredProducts);



	const [products, setProducts] = useState([]); // State to store categories
	const [activeCategory, setActiveCategory] = useState("all"); // State to store the active category
	const [selectedCategoryId, setSelectedCategoryId] = useState();
	// //(selectedCategoryId,"selectedCategoryId");

	const { holdLoad, setHoldLoadOrderFunc } = useContext(DineContext);
	const [toVariantCountKot, setToVariantCountKot] = useState([]);

	// //(toVariantCountKot);




	const [activeProductType, setActiveProductType] = useState(null); // State to store the active category
	const [searchQuery, setSearchQuery] = useState(""); // State to store the search query

	// New state for Tax logic
	const [genSettings, setGenSettings] = useState(null);
	const [taxGroups, setTaxGroups] = useState([]);
	const [selectCounts, setSelectCounts] = useState(false);
	const [selectedQuantityVKOT, setSelectedQuantityVKOT] = useState("");
	const [selectedQuantityVRate, setSelectedQuantityVRate] = useState("");
	const [selectedQuantityVName, setSelectedQuantityVName] = useState("");
	const [nonVPRate, setNonVPRate] = useState("");

	const [addonsToViewFromSelectedAddon, setAddonsToViewFromSelectedAddon] =
		useState([]);

	// //("addonsToViewFromSelectedAddon",addonsToViewFromSelectedAddon);

	const [holdInformations, setHoldInformations] = useState([]);

	const handleGetHoldOrders = async () => {
		try {
			const response = await axios.get(
				`${api_base_url}/getHoldOrders/${logginedDB}`
			);
			if (response.status == 200) {
				setHoldInformations(response.data);
			}
		} catch (error) {
			//(error);
		}
	};

	const socketRef = useRef(null);
	const handlersRef = useRef({});

	useEffect(() => {
		if (!logginedDB) return;

		handleGetHoldOrders();
		fetchProductionStatus();

		handlersRef.current = {
			handleGetHoldOrders,
			fetchProductionStatus,
			handleGetRunningOrders
		};

		socketRef.current = io(api_base_url, {
			transports: ["websocket"],
		});

		socketRef.current.on("connect", () => {
			console.log("Connected to server");
		});

		socketRef.current.on("disconnect", () => {
			console.log("Disconnected from server");
		});

		socketRef.current.on("connect_error", (error) => {
			console.error("Connection error:", error);
		});

		const onUpdateHoldOrders = () => handlersRef.current.handleGetHoldOrders?.();
		const onProductionUpdate = () => handlersRef.current.fetchProductionStatus?.();
		const onUpdateRunningOrders = () => handlersRef.current.handleGetRunningOrders?.();

		socketRef.current.on("updateHoldOrders", onUpdateHoldOrders);
		socketRef.current.on("productionUpdate", onProductionUpdate);
		socketRef.current.on("updateFoodIsReady", onUpdateRunningOrders);
		socketRef.current.on("updateKot", onUpdateRunningOrders);
		socketRef.current.on("tableReg", onUpdateRunningOrders);

		return () => {
			if (socketRef.current) {
				socketRef.current.off("updateHoldOrders", onUpdateHoldOrders);
				socketRef.current.off("productionUpdate", onProductionUpdate);
				socketRef.current.off("updateFoodIsReady", onUpdateRunningOrders);
				socketRef.current.off("updateKot", onUpdateRunningOrders);
				socketRef.current.off("tableReg", onUpdateRunningOrders);
				socketRef.current.disconnect();
			}
		};
	}, [api_base_url, logginedDB]);


	// useEffect(() => {
	//     fetch(`${api_base_url}/getItemReg/${Database}`)
	//         .then((response) => response.json())
	//         .then((ProData) => {
	//             if (ProData.success && Array.isArray(ProData.data)) {
	//                 setProducts(ProData.data);
	//                 // setFilteredProducts(ProData.data); // Initially show all products
	//                 // //(ProData.data, "product.data")
	//             } else {
	//                 // //("ekse getitemrewg")
	//                 setProducts([]);
	//                 setFilteredProducts([]);
	//             }
	//         })
	//         .catch((error) => console.error("Error fetching products:", error));
	// }, [api_base_url, Database]);

	const handleGetItems = async () => {
		try {
			const response = await fetch(
				`${api_base_url}/getItemReg/${Database}/${customerCode}`
			);
			const ProData = await response.json();
			if (ProData.success && Array.isArray(ProData.data)) {
				setProducts(ProData.data);
			} else {
				setProducts([]);
				setFilteredProducts([]);
			}
		} catch (error) {
			console.error("Error fetching products:", error);
			setProducts([]);
			setFilteredProducts([]);
		}
	};

	const handleGetCategories = async () => {
		try {
			const response = await fetch(
				`${api_base_url}/GetCategories/${logginedDB}`
			);
			const CateData = await response.json();
			if (CateData.success && Array.isArray(CateData.data)) {
				setCategories(CateData.data);
			} else {
				console.error("Error: Unsuccessful response");
				setCategories([]);
			}
		} catch (error) {
			console.error("Error fetching categories:", error);
			setCategories([]);
		}
	};

	const handleGetSettings = async () => {
		try {
			const response = await axios.get(`${api_base_url}/api/settings/${logginedDB}`);
			setGenSettings(response.data);
		} catch (error) {
			console.error("Error fetching settings:", error);
		}
	};

	const handleGetTaxGroups = async () => {
		try {
			const response = await axios.get(`${api_base_url}/getTaxGroups/${logginedDB}`);
			setTaxGroups(response.data || []);
		} catch (error) {
			console.error("Error fetching tax groups:", error);
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			await handleGetCategories();
			await handleGetItems();
			await handleGetSettings();
			await handleGetTaxGroups();
			await fetchProductionStatus();
		};
		fetchData();
	}, [api_base_url, logginedDB, customerCode, fetchProductionStatus]);

	useEffect(() => {
		// Automatically select the first category when both products and categories are ready
		if (categories.length > 0 && products.length > 0) {
			handleCategoryClick(categories[0].id_category);
		}
	}, [categories, products]);

	const calculateAdjustedTotal = () => {
		// Parse input values to numbers(if they are not empty)
		const deliveryCharge = inputValueDeliveryCharge
			? parseFloat(inputValueDeliveryCharge)
			: 0;
		const containerCharge = inputValueContainerCharge
			? parseFloat(inputValueContainerCharge)
			: 0;
		const customerPaid = inputValueCustomerPaid
			? parseFloat(inputValueCustomerPaid)
			: 0;
		const tip = inputValueTip ? parseFloat(inputValueTip) : 0;

		const valueInsideDivNum = total ? parseFloat(total) : 0;
		// Customer paid is compared against the payable amount; it is not part of the bill total.
		const billTax = calculateBillTax(valueInsideDivNum);
		const taxToAdd = genSettings?.isTaxInclusive === 1 ? 0 : billTax.totalTax;
		const totalV = deliveryCharge + containerCharge + tip + valueInsideDivNum + taxToAdd;

		return totalV;
	};

	const calculateBillTax = (amount) => {
		if (!genSettings || genSettings.Tax_Mode === "NONE") {
			return { cgst: 0, sgst: 0, totalTax: 0 };
		}

		const defaultTax = (taxGroups || []).find(
			(t) => String(t.id_tax) === String(genSettings.Default_Tax_Id)
		);
		const taxPercent = parseFloat(defaultTax?.gstPercent) || 0;
		const baseAmount = parseFloat(amount) || 0;
		let totalTax = 0;

		if (taxPercent > 0 && baseAmount > 0) {
			if (genSettings.isTaxInclusive === 1) {
				totalTax = baseAmount - baseAmount / (1 + taxPercent / 100);
			} else {
				totalTax = baseAmount * (taxPercent / 100);
			}
		}

		return {
			cgst: totalTax / 2,
			sgst: totalTax / 2,
			totalTax,
		};
	};

	const calculateCustomerBalance = () => {
		const customerPaid = inputValueCustomerPaid
			? parseFloat(inputValueCustomerPaid)
			: 0;
		const payableTotal = calculateAdjustedTotal();
		const balance = customerPaid - payableTotal;

		return {
			customerPaid,
			payableTotal,
			balanceReturn: balance > 0 ? balance : 0,
			balanceDue: balance < 0 ? Math.abs(balance) : 0,
		};
	};

	const handleSetTotal = () => {
		const totalV = calculateAdjustedTotal();

		// Update totalValue state
		setTotalValue(totalV.toFixed(2)); // Round to 2 decimal places and update state
		const intervalId = setInterval(() => {
			setDateTime(new Date());
		}, 1000);
		return () => clearInterval(intervalId);
	};

	useEffect(() => {
		handleSetTotal();
	}, [
		inputValueDeliveryCharge,
		inputValueContainerCharge,
		inputValueCustomerPaid,
		inputValueTip,
		total,
		genSettings,
		taxGroups,
		discount
	]);

	const formattedDateTime = dateTime.toLocaleString("en-Us");


	// Function to handle input changes
	const handleInputChange = (event, setInputValue) => {
		setInputValue(event.target.value);
		setIsBillAmountAdded(false);
	};

	const handleAddAmountsToBill = () => {
		const payableTotal = calculateAdjustedTotal().toFixed(2);
		const billTax = calculateBillTax(parseFloat(total) || 0);
		const customerBalance = calculateCustomerBalance();
		const adjustments = {
			baseTotal: parseFloat(total) || 0,
			deliveryCharge: parseFloat(inputValueDeliveryCharge) || 0,
			containerCharge: parseFloat(inputValueContainerCharge) || 0,
			customerPaid: parseFloat(inputValueCustomerPaid) || 0,
			tip: parseFloat(inputValueTip) || 0,
			discountAmount: parseFloat(discountAmt) || 0,
			cgst: billTax.cgst,
			sgst: billTax.sgst,
			totalTax: billTax.totalTax,
			balanceDue: customerBalance.balanceDue,
			balanceReturn: customerBalance.balanceReturn,
			netTotal: parseFloat(payableTotal) || 0,
		};

		setAddedBillTotal(payableTotal);
		setAddedBillAdjustments(adjustments);
		setIsBillAmountAdded(true);
		toast.success("Amounts added to bill.", {
			className: "custom-toast",
			bodyClassName: "custom-toast-container",
			closeButtonClassName: "custom-toast-close-button",
			onClose: () => { },
		});
	};

	const increment = (productId, varientId = null) => {
		if (previousOrders.length > 0 && !hasPermission('editKOT')) {
			alert("You do not have permission to edit KOT / add items to a running order!");
			return;
		}
		const product = products.find(p => p.id_productReg === productId);
		let factor = 1.0;
		if (varientId && product && product.varients) {
			const variant = product.varients.find(v => String(v.variantId) === String(varientId));
			if (variant && variant.deductionFactor !== undefined && variant.deductionFactor !== null) {
				factor = parseFloat(variant.deductionFactor);
			}
		}
		const remaining = getRemainingStock(productId);
		if (remaining < factor) {
			Swal.fire({
				icon: 'warning',
				title: 'Insufficient Stock',
				text: `Cannot add more. Only ${remaining.toFixed(2)} base portions left, but this variant requires ${factor}!`,
				confirmButtonColor: '#0008B4'
			});
			return;
		}
		setSelectedItems((prevItems) =>
			prevItems.map((item) => {
				// Check if the item matches both productId and varientId (if applicable)
				if (
					item.productId === productId &&
					(varientId === null || item.varientId === varientId)
				) {
					return {
						...item,
						quantity: item.quantity + 1, // Increment the quantity
					};
				}
				return item; // Return the item as is if it doesn't match
			})
		);
	};

	const incrementAddon = (productId, varientId, addonId) => {
		setAddonsToViewFromSelectedAddon((prevState) => {
			const key = varientId ? `${productId}_${varientId}` : productId;
			const updatedAddons = prevState[key].map((addon) => {
				if (
					addon.productId === productId &&
					addon.varientId === varientId &&
					addon.addonId === addonId
				) {
					return {
						...addon,
						quantity: (addon.quantity || 1) + 1, // Increment the quantity
					};
				}
				return addon; // Return the addon as is if it doesn't match
			});

			return {
				...prevState,
				[key]: updatedAddons,
			};
		});
	};

	const handleOnChangeQtyInput = (e, productId, varientId = null) => {
		const val = parseInt(e.target.value, 10); // Parse the value as an integer

		if (isNaN(val) || val < 1) return; // Ensure the value is a valid number and at least 1

		const product = products.find(p => p.id_productReg === productId);
		const tracking = getProductTrackingInfo(product);

		if (tracking.isTracked) {
			if (tracking.isSoldOut) {
				Swal.fire({
					icon: 'warning',
					title: 'Unavailable',
					text: 'This item is not available today!',
					confirmButtonColor: '#0008B4'
				});
				return;
			}

			// Find factor for this variant
			let currentFactor = 1.0;
			if (varientId && product.varients) {
				const variant = product.varients.find(v => String(v.variantId) === String(varientId));
				if (variant && variant.deductionFactor !== undefined && variant.deductionFactor !== null) {
					currentFactor = parseFloat(variant.deductionFactor);
				}
			}

			// Sum up the portion deductions for OTHER selected items of this product
			const otherSelectedDeduction = selectedItems
				.filter(item => item.productId === productId && !(item.varientId === varientId || (varientId === null && !item.varientId)))
				.reduce((sum, item) => {
					let factor = 1.0;
					if (item.varientId && product.varients) {
						const variant = product.varients.find(v => String(v.variantId) === String(item.varientId));
						if (variant && variant.deductionFactor !== undefined && variant.deductionFactor !== null) {
							factor = parseFloat(variant.deductionFactor);
						}
					}
					return sum + ((item.quantity || 0) * factor);
				}, 0);

			const allowedPortions = tracking.available_qty - otherSelectedDeduction;
			const requestedDeduction = val * currentFactor;

			if (requestedDeduction > allowedPortions) {
				const maxQty = Math.floor(allowedPortions / currentFactor);
				Swal.fire({
					icon: 'warning',
					title: 'Insufficient Stock',
					text: `Only ${allowedPortions.toFixed(2)} base portions are available today! Max quantity allowed for this variant is ${maxQty}.`,
					confirmButtonColor: '#0008B4'
				});
				return;
			}
		}

		setSelectedItems((prevItems) =>
			prevItems.map((item) => {
				// Check if the item matches both productId and varientId (if applicable)
				if (
					item.productId === productId &&
					(varientId === null || item.varientId === varientId)
				) {
					return {
						...item,
						quantity: val, // Update quantity to the new value
					};
				}
				return item; // Return the item as is if it doesn't match
			})
		);
	};

	const handleOnChangeQtyInputAddon = (e, productId, varientId, addonId) => {
		const val = parseInt(e.target.value, 10); // Parse the value as an integer

		if (isNaN(val) || val < 1) return; // Ensure the value is a valid number and at least 1

		setAddonsToViewFromSelectedAddon((prevState) => {
			const key = varientId ? `${productId}_${varientId}` : productId;
			const updatedAddons = prevState[key].map((addon) => {
				if (
					addon.productId === productId &&
					addon.varientId === varientId &&
					addon.addonId === addonId
				) {
					return {
						...addon,
						quantity: val, // Update quantity to the new value
					};
				}
				return addon; // Return the addon as is if it doesn't match
			});

			return {
				...prevState,
				[key]: updatedAddons,
			};
		});
	};

	const handleFocusQtyInput = (e, productId, varientId = null) => {
		// Retrieve the current quantity from the selectedItems array
		setSelectedItems((prevItems) =>
			prevItems.map((item) => {
				if (
					item.productId === productId &&
					(varientId === null || item.varientId === varientId)
				) {
					// If the quantity exists, set the input field to that value
					e.target.value = item.quantity || "";
					return item;
				}
				return item;
			})
		);
	};

	const handleFocusQtyInputAddon = (e, productId, varientId, addonId) => {
		const key = varientId ? `${productId}_${varientId}` : productId;
		setAddonsToViewFromSelectedAddon((prevState) => {
			// Loop through the addons for the given key
			const updatedAddons = prevState[key].map((addon) => {
				if (
					addon.productId === productId &&
					addon.varientId === varientId &&
					addon.addonId === addonId
				) {
					// Set the input value to the addon's quantity
					e.target.value = addon.quantity || "";
					return addon;
				}
				return addon; // Return the addon as is if it doesn't match
			});

			return {
				...prevState,
				[key]: updatedAddons,
			};
		});
	};

	const handleBlurQtyInput = (e, productId, varientId = null) => {
		const val = e.target.value;

		setSelectedItems((prevItems) =>
			prevItems.map((item) => {
				// Check if the item matches both productId and varientId (if applicable)
				if (
					item.productId === productId &&
					(varientId === null || item.varientId === varientId)
				) {
					return {
						...item,
						quantity: val.trim() === "" ? 1 : parseInt(val, 10), // Set to 1 if empty, otherwise use the entered value
					};
				}
				return item; // Return the item as is if it doesn't match
			})
		);
	};

	const handleBlurQtyInputAddon = (e, productId, varientId, addonId) => {
		const val = e.target.value;

		setAddonsToViewFromSelectedAddon((prevState) => {
			const key = varientId ? `${productId}_${varientId}` : productId;
			const updatedAddons = prevState[key].map((addon) => {
				if (
					addon.productId === productId &&
					addon.varientId === varientId &&
					addon.addonId === addonId
				) {
					return {
						...addon,
						quantity: val.trim() === "" ? 1 : parseInt(val, 10) || 1, // Default to 1 if input is empty or invalid
					};
				}
				return addon; // Return the addon as is if it doesn't match
			});

			return {
				...prevState,
				[key]: updatedAddons,
			};
		});
	};

	const decrement = (productId, varientId = null) => {
		if (previousOrders.length > 0 && !hasPermission('editKOT')) {
			alert("You do not have permission to edit KOT / change quantities on a running order!");
			return;
		}
		setSelectedItems((prevItems) =>
			prevItems.map((item) => {
				// Check if the item matches both productId and varientId (if applicable)
				if (
					item.productId === productId &&
					(varientId === null || item.varientId === varientId)
				) {
					return {
						...item,
						quantity: Math.max(item.quantity - 1, 1), // Ensure quantity doesn't go below 1
					};
				}
				return item; // Return the item as is if it doesn't match
			})
		);
	};

	const decrementAddon = (productId, varientId, addonId) => {
		setAddonsToViewFromSelectedAddon((prevState) => {
			const key = varientId ? `${productId}_${varientId}` : productId;
			const updatedAddons = prevState[key].map((addon) => {
				if (
					addon.productId === productId &&
					addon.varientId === varientId &&
					addon.addonId === addonId
				) {
					return {
						...addon,
						quantity: Math.max((addon.quantity || 1) - 1, 1), // Ensure quantity doesn't go below 1
					};
				}
				return addon; // Return the addon as is if it doesn't match
			});

			return {
				...prevState,
				[key]: updatedAddons,
			};
		});
	};


	useEffect(() => {
		// whenever products refetch -> reset to "all"
		if (products?.length > 0) {
			setActiveCategory("all");
			setFilteredProducts(products);
			setNoProductsMessage(false);
		}
	}, [products]);

	const handleCategoryClick = (categoryId) => {
		setActiveCategory(categoryId);

		if (categoryId === "all") {
			setFilteredProducts(products);
			setNoProductsMessage(false);
		} else {
			const filtered = products.filter(
				(product) => String(product.category) === String(categoryId)
			);
			setFilteredProducts(filtered);
			setNoProductsMessage(filtered.length === 0);
		}
	};

	// const handleItemClick = (product) => {
	//     //("Selected Product:", product);
	// };

	const handleItemClick = (productClicked) => {
		if (previousOrders.length > 0 && !hasPermission('editKOT')) {
			alert("You do not have permission to edit KOT / add items to a running order!");
			return;
		}
		const isAlreadySelected = selectedItems.some(
			(item) => item.productId === productClicked.id_productReg
		);
		const hasVariants =
			productClicked.varients && productClicked.varients.length > 0;
		setToVariantCountKot(productClicked);
		if (!isVisible) {
			if (isAlreadySelected && !hasVariants) {
				alert("already selected!");
			} else {
				setSelectCount(true);
			}
		}
	};

	// //(toVariantCountKot)
	const processProducts = (products, activeCategory) => {
		const updatedProducts = products
			.filter(
				(product) => !activeCategory || product.categoryId === activeCategory
			) // Filter based on activeCategory
			.map((product) => ({
				...product,
				bgColor: product.foodType === "2" ? "#dff0d8" : "#f2dede", // Assign color based on foodType
			}));
		setProcessedProducts(updatedProducts);
	};

	useEffect(() => {
		processProducts(products, activeCategory);
	}, [products, activeCategory]);

	const handleSectionClick = (id) => {
		setActiveSection(id);
	};

	const removeItem = (productId, varientId = null) => {
		setSelectedItems((prevItems) =>
			prevItems.filter((item) => {
				// Retain items that do not match the productId and varientId
				return !(
					item.productId === productId &&
					(varientId === null || item.varientId === varientId)
				);
			})
		);

		setAlreadySelectedVariants((prevVariants) => {
			// Create a copy of the current state
			const updatedVariants = { ...prevVariants };

			if (updatedVariants[productId]) {
				if (varientId === null) {
					// Remove the entire productId entry
					delete updatedVariants[productId];
				} else {
					// Remove the specific variantId from the array
					updatedVariants[productId] = updatedVariants[productId].filter(
						(id) => id !== varientId
					);

					// If the array becomes empty, remove the productId key
					if (updatedVariants[productId].length === 0) {
						delete updatedVariants[productId];
					}
				}
			}

			return updatedVariants;
		});

		// Remove item from addonsToViewFromSelectedAddon
		const key = varientId ? `${productId}_${varientId}` : productId;

		setAddonsToViewFromSelectedAddon((prevAddons) => {
			// Create a copy of the current state
			const updatedAddons = { ...prevAddons };

			// Remove the key from the object
			if (updatedAddons[key]) {
				delete updatedAddons[key];
			}

			return updatedAddons;
		});
	};

	const removeAddon = (productId, varientId, addonId) => {
		// Remove item from addonsToViewFromSelectedAddon
		const key = varientId ? `${productId}_${varientId}` : productId;

		setAddonsToViewFromSelectedAddon((prevAddons) => {
			// Create a copy of the current state
			const updatedAddons = { ...prevAddons };

			if (updatedAddons[key]) {
				// Filter out the addon with the matching addonId
				updatedAddons[key] = updatedAddons[key].filter(
					(addon) => addon.addonId !== addonId
				);

				// If the array becomes empty, remove the key from the object
				if (updatedAddons[key].length === 0) {
					delete updatedAddons[key];
				}
			}

			return updatedAddons;
		});
	};

	const [viewOrders, setViewOrders] = useState(false);
	const [mobileKOT, setMobileKOT] = useState(true);
	const [menuFooterMobile, setMenuFooterMobile] = useState(true);

	const [clickedItems, setClickedItems] = useState([]);

	const [onClickItemCount, setOnClickItemCount] = useState(null);

	const [itemCounts, setItemCounts] = useState({});

	const [mobileKOTOpacityDown, setMobileKOTOpacityDown] = useState(false);

	const handleChangeCount = (e, itemId) => {
		const value = e.target.value;
		setItemCounts(value);
	};

	const [searchInput, setSearchInput] = useState("");
	const handleSearchItem = (e) => {
		const itemName = e.target.value;
		setSearchInput(itemName);
	};

	// //(products);
	const [part, setPart] = useState(false);

	const [selectedPayment, setSelectedPayment] = useState("");

	const [showPaymentInfo, setShowPaymentInfo] = useState(false);

	const [payments, setPayments] = useState(null);

	// console.log('payments',payments);

	const handleCheckRadio = (field) => {
		console.log("Function called for:", field);
		if (!hasPermission('takePayments')) {
			alert("You do not have permission to take payments / settle orders!");
			return;
		}
		if (field === "part") {
			setPart(true);
		} else {
			setPayments(null);
			setShowPaymentInfo(false);
		}
		// Only update state if the same option isn't clicked twice
		if (selectedPayment !== field) {
			setSelectedPayment(field);
		}
	};

	const filteredItemsDesktop = filteredProducts.filter((item) =>
		item.productName.toLowerCase().includes(searchInput.toLowerCase())
	);

	const filteredItems = products.filter((item) =>
		item.productName.toLowerCase().includes(searchInput.toLowerCase())
	);

	const [itemsNetTotal, setItemsNetTotal] = useState({});

	const [selectedItemInfo, setSelectedItemInfo] = useState({});
	const [selectedAddOnInfo, setSelectedAddOnInfo] = useState({});
	const [selectedRequestLog, setSelectedRequestLog] = useState({});

	// //('selectedItemInfo',selectedItemInfo);
	const [itemToEditState, setItemToEditState] = useState(false);

	const handleModifyItemsMob = (item) => {
		// //('item',selectedItemInfo[item]);
		const itemToModify = products.filter(
			(product) => product.productName === item
		);
		// //('itemToModify',itemToModify);
		setMobileKOT(true);
		setViewOrders(false);
		setItemToEditState(true);
		setOnClickItemCount(itemToModify[0]);
	};

	const [customerInfo, setCustomerInfo] = useState(false);

	const toCustomerInfo = () => {
		const combinedData = {};

		Object.keys(selectedItemInfo).forEach((key) => {
			combinedData[key] = {
				item: Object.values(selectedItemInfo[key] || {}),
				addon: Object.values(selectedAddOnInfo[key] || {}),
				requestLog: selectedRequestLog[key] || "",
			};
		});

		setCustomerInfo(true);
	};

	const [totalNetAmount, setTotalNetAmount] = useState();
	const [totalItemSelected, setTotalItemSelected] = useState();

	const toDisplayNetTotal = () => {
		let total = 0;

		for (let key in itemsNetTotal) {
			if (itemsNetTotal.hasOwnProperty(key)) {
				total += itemsNetTotal[key];
			}
		}

		setTotalNetAmount(total);
	};

	const findTotalItemSelected = () => {
		setTotalItemSelected(clickedItems.length);
	};

	useEffect(() => {
		toDisplayNetTotal();
		findTotalItemSelected();
	}, []);

	const handleOnClose = () => {
		setSelectCount(!selectCount);
	};

	const handleFocus = () => {
		setVariantCount(false);
	};

	// //(selectedItems);

	const handleSaveInParent = (
		countsVKOT,
		selectedVariant,
		product,
		selectedAddon,
		remarks
	) => {
		// //("selectedVariant",selectedVariant);

		if (!product || !product.id_productReg) {
			console.error("Invalid product object:", product);
			return;
		}

		let factor = 1.0;
		if (selectedVariant && selectedVariant.deductionFactor !== undefined && selectedVariant.deductionFactor !== null) {
			factor = parseFloat(selectedVariant.deductionFactor);
		}
		const requiredQty = countsVKOT * factor;

		const remaining = getRemainingStock(product.id_productReg);
		if (requiredQty > remaining) {
			Swal.fire({
				icon: 'warning',
				title: 'Insufficient Stock',
				text: `Cannot select ${countsVKOT} items. Only ${remaining.toFixed(2)} prepared base portions are left, but this requires ${requiredQty.toFixed(2)}!`,
				confirmButtonColor: '#0008B4'
			});
			return;
		}

		const productId = product.id_productReg;
		const rate = selectedVariant?.variantRate || product.rate || 0; // Use variantRate or fallback to product.rate
		const name = selectedVariant?.variantName || ""; // Fallback to "No Variant"

		// //("selectedAddon",selectedAddon);

		if (selectedAddon) {
			const { total, ...addons } = selectedAddon;

			//("total",total);

			setAddonsToViewFromSelectedAddon((prevState) => {
				const updatedState = { ...prevState }; // Clone the previous state

				let transformedAddOns;

				if (selectedVariant) {
					transformedAddOns = Object.entries(addons).map(([id, details]) => ({
						productId: productId,
						productName: product.productName,
						variantName: name,
						addonName: details.name,
						quantity: details.count,
						varientId: selectedVariant.variantId,
						addonId: parseInt(id, 10),
						rate: details.price,
					}));

					// Check if the productId already exists in the state
					if (!updatedState[`${productId}_${selectedVariant.variantId}`]) {
						updatedState[`${productId}_${selectedVariant.variantId}`] = []; // Initialize if not present
					}

					updatedState[`${productId}_${selectedVariant.variantId}`] = [
						...updatedState[`${productId}_${selectedVariant.variantId}`],
						...transformedAddOns,
					];
				} else {
					transformedAddOns = Object.entries(addons).map(([id, details]) => ({
						productId: productId,
						productName: product.productName,
						addonName: details.name,
						quantity: details.count,
						addonId: parseInt(id, 10),
						rate: details.price,
					}));

					// Check if the productId already exists in the state
					if (!updatedState[productId]) {
						updatedState[productId] = []; // Initialize if not present
					}

					updatedState[productId] = [
						...updatedState[productId],
						...transformedAddOns,
					];
				}

				// //("updatedState",updatedState);

				return updatedState;
			});
		}

		if (selectedVariant) {
			setSelectedItems([
				...selectedItems,
				{
					productId: productId,
					productName: product.productName,
					quantity: countsVKOT,
					varientId: selectedVariant.variantId,
					variantName: name,
					variantRate: rate,
					remarks: remarks,
				},
			]);
		} else {
			setSelectedItems([
				...selectedItems,
				{
					productId: product.id_productReg,
					productName: product.productName,
					quantity: countsVKOT,
					rate: product.rate,
					remarks: remarks,
				},
			]);
		}
	};

	const [variantCountSaved, setVariantCountSaved] = useState();
	const variantCountOnSave = (count) => {
		setVariantCountSaved(count);
		setVariantCount(false);
		if (count > 0) {
			setVariantItemColor(true);
			setNoCount(true);
		} else {
			setVariantItemColor(false);
			setNoCount(false);
		}
	};
	const [variantCount, setVariantCount] = useState(false);
	const [variantItemColor, setVariantItemColor] = useState(false);
	const handleOnClickVariantItem = () => {
		setVariantCount(true);
	};
	const [noCount, setNoCount] = useState(false);
	const [sideNav, setSideNav] = useState(false);
	const handleSideNav = (state) => {
		setSideNav(state);
	};
	// const [table_,setTable_] = useState(null)

	const [falseState, setFalseState] = useState(null);

	const [billNo, setBillNo] = useState(null);
	const [isSaving, setIsSaving] = useState(false)
	const directOrderTypes = ["delivery", "pickup", "parcel"];
	const isDirectOrder = directOrderTypes.includes(for_);
	const kotTableNo = tableNo_ || (isDirectOrder ? for_ : "");
	const kotAreaId = area_id_ || (isDirectOrder ? 0 : "");
	const kotTableType = table_ || (isDirectOrder ? for_ : "");
	const kotDineType = DineType || (isDirectOrder ? for_ : table_);

	function validateCustomerData(data) {
		const errors = [];

		if (!data.name || !data.name.trim()) {
			errors.push("Customer name is required");
		}

		if (data.mobile) {
			const mobileRegex = /^[0-9]{10}$/;
			if (!mobileRegex.test(data.mobile.toString())) {
				errors.push("Mobile number must be 10 digits");
			}
		}

		if (data.due && isNaN(parseFloat(data.due))) {
			errors.push("Due amount must be a valid number");
		}

		return errors;
	}

	// const validationErrors = validateCustomerData(req.body);
	// if (validationErrors.length > 0) {
	// 	return res.status(400).send({
	// 		success: false,
	// 		messages: validationErrors
	// 	});
	// }

	const handleSaveCustomer = async () => {
		if (isSaving) return; // Prevent multiple clicks

		setIsSaving(true);

		try {
			// Validate required fields
			if (!customerDetails.mobile || !customerDetails.name) {
				toast.error(`Mobile and Name are required fields`, {
					className: "custom-toast",
					bodyClassName: "custom-toast-container",
					closeButtonClassName: "custom-toast-close-button",
					onClose: () => { },
				});
				return;
			}
			// Prepare the data for backend
			const payload = {
				mobile: customerDetails.mobile.toString(),
				name: customerDetails.name,
				address: customerDetails.addr || "",
				locality: customerDetails.loc || "",
				dueAmount: customerDetails.due || 0,
				// Add any additional fields your backend needs
			};
			console.log(payload, "payload to save customer");

			const response = await axios.post(
				`${api_base_url}/CustomersReg/${logginedDB}`,
				payload,
				{
					headers: {
						'Content-Type': 'application/json',
						// Add authorization if needed
						// 'Authorization': `Bearer ${token}`
					}
				}
			);

			if (response.status === 201 || response.status === 200) {
				// Show success message
				console.log("Customer saved successfully:", response.data);
				toast.success(`Customer Registered`, {
					className: "custom-toast",
					bodyClassName: "custom-toast-container",
					closeButtonClassName: "custom-toast-close-button",
					onClose: () => { },
				});

			} else {
				console.log("Customer details registration failed:");
				toast.error(`Customer details registration failed:`, {
					className: "custom-toast",
					bodyClassName: "custom-toast-container",
					closeButtonClassName: "custom-toast-close-button",
					onClose: () => { },
				});
			}
		} catch (error) {
			console.error('Error:', error);

			// Better error handling
			if (error.response) {
				// The request was made and the server responded with a status code
				console.error('Response error:', error.response.data);
				// alert(`Error: ${error.response.data.message || 'Failed to save customer'}`);
				toast.error(`Error: ${error.response.data.message || 'Failed to save customer'}`, {
					className: "custom-toast",
					bodyClassName: "custom-toast-container",
					closeButtonClassName: "custom-toast-close-button",
					onClose: () => { },
				});
			} else if (error.request) {
				// The request was made but no response was received
				console.error('No response received:', error.request);
				// alert('No response from server. Please check your connection.');
				toast.error(`No response from server. Please check your connection.`, {
					className: "custom-toast",
					bodyClassName: "custom-toast-container",
					closeButtonClassName: "custom-toast-close-button",
					onClose: () => { },
				});
			} else {
				// Something happened in setting up the request
				console.error('Request setup error:', error.message);
				alert('Error setting up request.');
				toast.error(`Error setting up request.`, {
					className: "custom-toast",
					bodyClassName: "custom-toast-container",
					closeButtonClassName: "custom-toast-close-button",
					onClose: () => { },
				});
			}
		} finally {
			setIsSaving(false);
		}
	};

	const handleSaveKotAndBill = async () => {
		if (!hasPermission('takePayments')) {
			alert("You do not have permission to take payments / settle orders!");
			return;
		}
		let finalPayments;

		if (isComplimentary) {
			// Complimentary bill â€” no payment type required, zero out the amount
			finalPayments = { complimentary: prevOrderTotal };
		} else if (payments && Object.keys(payments).length > 0) {
			const partpay = Object.entries(payments).filter(
				([_, value]) => value !== "" && value !== 0
			);

			finalPayments =
				partpay.length > 0
					? partpay.reduce((acc, [key, value]) => {
						acc[key] = value;
						return acc;
					}, {})
					: { [selectedPayment]: prevOrderTotal };
		} else {
			finalPayments = { [selectedPayment]: prevOrderTotal };
		}

		if (previousOrders.length === 0) {
			return alert("No Kot available!");
		}

		// Skip payment-type check for complimentary bills
		if (!isComplimentary && (!selectedPayment || selectedPayment === "")) {
			return alert("please select payment type!");
		}

		// //(previousOrders);

		const formData = new FormData();

		const updatedSavedItems = [
			...previousOrders,
			formattedDateTime,
			userType,
			finalPayments,
		];

		formData.append("savedItems", JSON.stringify(updatedSavedItems));
		formData.append("discount", discountAmt || 0);
		formData.append("otherCharges", (parseFloat(inputValueDeliveryCharge) || 0) + (parseFloat(inputValueContainerCharge) || 0));
		formData.append("netAmount", totalValue || 0);
		const billTax = calculateBillTax(parseFloat(total) || prevOrderTotal);
		formData.append("cgst", billTax.cgst.toFixed(2));
		formData.append("sgst", billTax.sgst.toFixed(2));
		formData.append("totalTax", billTax.totalTax.toFixed(2));

		// Breaking down payments
		formData.append("cashReceived", finalPayments.cash || 0);
		formData.append("cardAmount", finalPayments.card || 0);
		formData.append("onlineAmount", finalPayments.online || 0);
		formData.append("creditAmount", finalPayments.credit || 0);
		formData.append("is_complimentary", isComplimentary ? "true" : "false");
		if (billNo) {
			formData.append("billNo", billNo);
		}

		// formData.append('finalPayments', JSON.stringify(finalPayments));

		// //(tableNo_,area_id_);

		try {
			// const response = await fetch(`${api_base_url}/saveKotAndBill/${logginedDB}/${tableNo_}/${area_id_}/${table_}`, {
			//     method: 'POST',
			//     body: formData,
			// });
			console.log(kotDineType, "DineType KOT page", kotTableType);

			const response = await fetch(
				`${api_base_url}/saveKotAndBill/${logginedDB}/${kotTableNo}/${kotAreaId}/${kotTableType}/${kotDineType}`,
				{
					method: "POST",
					body: formData,
				}
			);

			if (response.ok) {
				const data = await response.json();
				console.log(data, "kot table as permanent ?");

				if (data.message === "printed") {
					if (data.table === "temp") {
						const result = await Swal.fire({
							// title: '<strong>Set Table as Permanent</strong>', // HTML title for formatting
							html: `
                            <p style="font-size: 16px; color: #555;">
                                Would you like to set this table as <b>permanent</b> ?
                            </p>
                        `, // Custom HTML content
							icon: "warning", // Warning icon
							iconColor: "#0008B4", // Custom icon color
							showCancelButton: true, // Show cancel button
							confirmButtonColor: "#4CAF50", // Custom confirm button color
							cancelButtonColor: "#F44336", // Custom cancel button color
							confirmButtonText: '<i class="fa fa-check"></i> Yes', // Custom confirm button text
							cancelButtonText: '<i class="fa fa-times"></i> No', // Custom cancel button text
							background: "#f9f9f9", // Custom background color
							customClass: {
								popup: "custom-popup", // Custom class for the popup (can style in CSS)
								confirmButton: "custom-confirm-btn", // Custom class for confirm button
								cancelButton: "custom-cancel-btn", // Custom class for cancel button
							},
							// footer: '<a href="https://your-website.com">Learn more about this action</a>', // Add footer link
							allowOutsideClick: false, // Prevent closing by clicking outside
							allowEscapeKey: false, // Prevent closing with the Escape key
							preConfirm: () => {
								return new Promise((resolve, reject) => {
									// Simulate a delay or perform validation
									setTimeout(() => {
										resolve(true);
									}, 1000);
								});
							},
						});

						if (result.isConfirmed) {
							try {
								// //("hhh",for_,area_id_);

								// Send request to backend
								const response = await fetch(
									`${api_base_url}/toPermanent/${logginedDB}/${for_}/${kotAreaId}`,
									{
										method: "POST",
									}
								);

								const data = await response.json();

								if (data.success) {
									toast.success(`Table set to permanent!`, {
										className: "custom-toast",
										bodyClassName: "custom-toast-container",
										closeButtonClassName: "custom-toast-close-button",
										onClose: () => { },
									});

									navigate("/TableView");
								} else {
									toast.error(`Error occurred`, {
										className: "custom-toast",
										bodyClassName: "custom-toast-container",
										closeButtonClassName: "custom-toast-close-button",
										onClose: () => { },
									});
								}
							} catch (err) {
								toast.error(`Error occurred`, {
									className: "custom-toast",
									bodyClassName: "custom-toast-container",
									closeButtonClassName: "custom-toast-close-button",
									onClose: () => { },
								});
							}
						} else {
							try {
								// //("hhh",for_,area_id_);

								// Send request to backend
								const response = await fetch(
									`${api_base_url}/toDeleteTemp/${logginedDB}/${for_}/${kotAreaId}`,
									{
										method: "POST",
									}
								);

								if (response.status === 200) {
									navigate("/TableView");
								}
							} catch (err) {
								toast.error(`Error occurred in deletion of Temp table!`, {
									className: "custom-toast",
									bodyClassName: "custom-toast-container",
									closeButtonClassName: "custom-toast-close-button",
									onClose: () => { },
								});
							}
						}
					} else {
						try {
							// Send request to backend
							const response = await fetch(
								`${api_base_url}/demergeTable/${logginedDB}/${for_}`,
								{
									method: "POST",
								}
							);

							if (response.status === 200) {
								toast.success(`Successfully saved!`, {
									className: "custom-toast",
									bodyClassName: "custom-toast-container",
									closeButtonClassName: "custom-toast-close-button",
									onClose: () => { },
								});
								navigate("/TableView");
							}
						} catch (err) { }
					}
				} else {
					alert("Not printed");
				}
			} else {
				console.error("Error in API call:", response.status);
			}
		} catch (error) {
			console.error("Fetch Error:", error);
		}
	};

	// const handleSaveKOT = async () => {
	// 	if (selectedItems.length === 0) {
	// 		return alert("please select a product!");
	// 	}

	// 	let selectedItemsWithAddons;

	// 	if (Object.values(addonsToViewFromSelectedAddon).flat().length > 0) {
	// 		selectedItemsWithAddons = [
	// 			...selectedItems,
	// 			...Object.values(addonsToViewFromSelectedAddon).flat(),
	// 		];
	// 	} else {
	// 		selectedItemsWithAddons = [...selectedItems];
	// 	}

	// 	// const updatedSavedItems = [...selectedItemsWithAddons, formattedDateTime, userType];
	// 	let updatedSavedItems = null;

	// 	const formData = new FormData();

	// 	let customerD = null;

	// 	if (customerDetails.mobile) {
	// 		customerD = JSON.stringify(customerDetails);
	// 		updatedSavedItems = [
	// 			...selectedItemsWithAddons,
	// 			formattedDateTime,
	// 			customerD,
	// 			userType,
	// 		];
	// 		console.log(updatedSavedItems, "inside if customer");
	// 	} else {
	// 		// return alert('Customer phone/mobile no. require!')
	// 		updatedSavedItems = [
	// 			...selectedItemsWithAddons,
	// 			formattedDateTime,
	// 			userType,
	// 		];
	// 		console.log(updatedSavedItems, "updatedSavedItems");
	// 	}
	// 	console.log(updatedSavedItems, "form ");
	// 	formData.append("savedItems", JSON.stringify(updatedSavedItems)); // Convert array to JSON

	// 	// console.log('customerDetails.persons',customerDetails.persons);

	// 	// if (!customerDetails.persons || customerDetails.persons === '') {
	// 	//     return alert("please select no of persons!")
	// 	// }

	// 	try {
	// 		let response;
	const handleSaveKOT = async () => {
		if (selectedItems.length === 0) {
			return alert("please select a product!");
		}

		let selectedItemsWithAddons;

		if (Object.values(addonsToViewFromSelectedAddon).flat().length > 0) {
			selectedItemsWithAddons = [
				...selectedItems,
				...Object.values(addonsToViewFromSelectedAddon).flat(),
			];
		} else {
			selectedItemsWithAddons = [...selectedItems];
		}

		const formData = new FormData();

		// Send customer details separately, not in savedItems
		let customerD = null;

		// Delivery orders require at least a customer name
		if (isDirectOrder && for_ === 'delivery' && !customerDetails.name) {
			return alert("Delivery order requires customer name and phone number!");
		}

		if (customerDetails.mobile) {
			customerD = JSON.stringify(customerDetails);
			formData.append("customer", customerD);
		} else if (customerDetails.name) {
			// Name-only (no mobile) â€” still persist for delivery
			customerD = JSON.stringify(customerDetails);
			formData.append("customer", customerD);
		}

		// Only items and metadata in savedItems
		const updatedSavedItems = [
			...selectedItemsWithAddons,
			formattedDateTime,
			userType,
		];

		console.log(updatedSavedItems, "updatedSavedItems");
		formData.append("savedItems", JSON.stringify(updatedSavedItems));

		try {
			let response;
			if (selectedTableForMerge.length > 0) {
				if ((billNo || previousOrders.length > 0) && !isValidMergedTables) {
					// const filteredTables = selectedTableForMerge.filter(table => table !== for_);

					// console.log('filteredTables',filteredTables);

					response = await axios.post(
						`${api_base_url}/MergeInRunningTable/${area_id_}/${totalPersons_}/${for_}/${logginedDB}`,
						selectedTableForMerge
					);

					if (response.status === 200) {
						// response = await fetch(`${api_base_url}/postToKOT/${logginedDB}/${tableNo_}/${area_id_}/${table_}/${for_}/${customerD}`, {
						response = await fetch(
							`${api_base_url}/postToKOT/${logginedDB}/${kotTableNo}/${kotAreaId}/${kotTableType}/${for_}`,
							{
								method: "POST",
								body: formData,
							}
						);
					}
				} else {
					response = await axios.post(
						`${api_base_url}/TableRegForMerge/${area_id_}/${totalPersons_}/${tableName_}/${logginedDB}`,
						selectedTableForMerge
					);

					if (response.status === 200) {
						const tableId = response.data.tableId;
						// formData.append('selectedTableForMerge', JSON.stringify(selectedTableForMerge));

						response = await fetch(
							`${api_base_url}/postToKOT/${logginedDB}/${tableName_}/${area_id_}/${"table"}/${tableId}`,
							{
								method: "POST",
								body: formData,
							}
						);
					}
				}
			} else {
				response = await fetch(
					`${api_base_url}/postToKOT/${logginedDB}/${kotTableNo}/${kotAreaId}/${kotTableType}/${for_}`,
					{
						method: "POST",
						body: formData,
					}
				);
			}

			if (response.ok) {
				const data = await response.json();
				navigate("/TableView");
			} else {
				console.error("Error in API call:", response.status);
			}
		} catch (error) {
			console.error("Fetch Error:", error);
		}
	};

	const [orderToKot, setOrderToKot] = useState(false);

	const handleKotAndPrint = async () => {


		let selectedItemsWithAddons;

		if (Object.values(addonsToViewFromSelectedAddon).flat().length > 0) {
			selectedItemsWithAddons = [
				...selectedItems,
				...Object.values(addonsToViewFromSelectedAddon).flat(),
			];
		} else {
			selectedItemsWithAddons = [...selectedItems];
		}

		if (selectedItems.length === 0) {
			return alert("please select a product!");
		}

		const updatedSavedItems = [
			...selectedItemsWithAddons,
			formattedDateTime,
			userType,
		];

		const formData = new FormData();

		formData.append("savedItems", JSON.stringify(updatedSavedItems)); // Convert array to JSON

		let customerD = null;

		if (isDirectOrder && for_ === 'delivery' && !customerDetails.name) {
			return alert("Delivery order requires customer name and phone number!");
		}

		if (customerDetails.mobile) {
			customerD = JSON.stringify(customerDetails);
			formData.append("customer", customerD); // Fix: was built but never appended
		} else if (customerDetails.name) {
			// Name-only customer (no mobile)
			customerD = JSON.stringify(customerDetails);
			formData.append("customer", customerD);
		}

		let response;

		try {
			if (selectedTableForMerge.length > 0) {
				response = await axios.post(
					`${api_base_url}/TableRegForMerge/${area_id_}/${totalPersons_}/${tableName_}/${logginedDB}`,
					selectedTableForMerge
				);

				if (response.status === 200) {
					const tableId = response.data.tableId;

					console.log("hiii", tableId);

					response = await fetch(
						`${api_base_url}/postToKOT/${logginedDB}/${tableName_}/${area_id_}/${"table"}/${tableId}`,
						{
							method: "POST",
							body: formData,
						}
					);
					// console.log("helooo",response);
				}
			} else {
				response = await fetch(
					`${api_base_url}/postToKOT/${logginedDB}/${kotTableNo}/${kotAreaId}/${kotTableType}/${for_}`,
					{
						method: "POST",
						body: formData,
					}
				);
			}

			if (response.ok) {
				const data = await response.json();
				if (data.billNo) {
					setBillNo(data.billNo);
				}
				setPrintBill(true);
				setOrderToKot(true);
			} else {
				console.error("Error in API call:", response.status);
			}
		} catch (error) {
			console.error("Fetch Error:", error);
		}
	};

	const [printBill, setPrintBill] = useState(false);

	// useEffect(() => {
	//     if (printBill) {
	//         //("helo");

	//         handlePrintBpos()
	//     }
	// }, [])

	const handlePrintBill = async () => {
		if (!hasPermission('generateBill')) {
			alert("You do not have permission to generate / print bills!");
			return;
		}
		if (billNo || previousOrders.length > 0) {
			setPrintBill(true);
			setPreviewPreviousOrders(false);
		} else {
			return alert("No Bill Available!");
		}
	};

	const mergeItemsForPrint = (items) => {
		return Object.values(
			items.reduce((acc, item) => {
				const rate = parseFloat(item.rate ?? item.variantRate ?? 0) || 0;
				const key = `${item.productId}-${item.varientId || ""}-${rate}`;

				if (!acc[key]) {
					acc[key] = {
						...item,
						rate,
						quantity: parseFloat(item.quantity) || 0,
					};
				} else {
					acc[key].quantity += parseFloat(item.quantity) || 0;
				}

				return acc;
			}, {})
		);
	};

	const mergeAddonsForPrint = (addons) => {
		return Object.values(
			addons.reduce((acc, addon) => {
				const rate = parseFloat(addon.rate) || 0;
				const key = `${addon.productId || ""}-${addon.varientId || ""}-${addon.addonId}-${rate}`;

				if (!acc[key]) {
					acc[key] = {
						...addon,
						rate,
						quantity: parseFloat(addon.quantity) || 0,
					};
				} else {
					acc[key].quantity += parseFloat(addon.quantity) || 0;
				}

				return acc;
			}, {})
		);
	};

	const currentPrintItems = mergeItemsForPrint([
		...previousSelectedItemsToBill,
		...selectedItems,
	]);

	const currentPrintAddons = mergeAddonsForPrint([
		...toIncludeAddonsToPrint,
		...Object.values(addonsToViewFromSelectedAddon).flat(),
	]);

	const setVariantCounts = (state) => {
		setSelectCount(state);
	};

	const [hover, setHover] = useState(null);

	const handleHoldLoadOrderFunc = (type) => {
		if (selectedItems.length === 0) {
			return alert("No items seleted to hold!");
		}
		setHoldLoadOrderFunc(type);
	};

	const [holdInfo, setHoldInfo] = useState({});

	const handleOnChangeInfo = (e, field) => {
		const val = e.target.value;
		setHoldInfo((prev) => ({
			...prev,
			[field]: val,
		}));
	};

	// (total etc moved to top)

	const handlePrintBpos = async () => {
		const htmlContent = printRef.current?.innerHTML;
		try {
			const response = await fetch(`${api_base_url}/printbpos`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ htmlContent }),
			});
			const result = await response.json();
			if (result.success) {
				setPrintBill(false);
				//("Printing Success!");
			} else {
				console.error("Print Error:", result.error);
			}
		} catch (error) {
			console.error("Fetch Error:", error);
		}
	};

	// const [prevOrderTotal, setPrevOrderTotal] = useState(0); (moved to top)

	const handleSetTotalOnRender = () => {
		let prevTotal = 0;

		if (previousOrders.length > 0) {
			//("previousOrders",previousOrders);

			const groupedOrders = Object.values(
				previousOrders.reduce((acc, order) => {
					const { kotno, Date, Time, kotstatus, remarks, ...itemDetails } =
						order;

					if (!acc[kotno]) {
						acc[kotno] = {
							kotNo: kotno,
							Date,
							Time,
							kotstatus,
							items: [], // Store items as an array
						};
					}

					const transformedItem = {
						productId: itemDetails.Itemid,
						productName: itemDetails.ItemName,
						quantity: itemDetails.Qty,
						rate: itemDetails.Rate,
						remarks: remarks,
						...(itemDetails.variantId && {
							variantName: itemDetails.VariantName,
							varientId: itemDetails.variantId,
						}),
						addons: [],
					};

					// Find if the item already exists in the items array
					let existingItemIndex = acc[kotno].items.findIndex(
						(item) =>
							item.productId === transformedItem.productId &&
							item.varientId === transformedItem.varientId
					);

					if (existingItemIndex === -1) {
						// Add a new item if not found
						acc[kotno].items.push(transformedItem);
						existingItemIndex = acc[kotno].items.length - 1;
					}

					// Add addons to the existing item if present
					if (itemDetails.addonId) {
						acc[kotno].items[existingItemIndex].addons.push({
							addonId: itemDetails.addonId,
							addonName: itemDetails.addonName,
							qty: itemDetails.Qty,
							rate: itemDetails.Rate,
						});
					}

					return acc;
				}, {})
			);

			//("groupedOrders",groupedOrders);

			setPreviousSelectedItems(groupedOrders);

			// only for bill......................................................

			const transformedData = previousOrders.map((item) => {
				const {
					Itemid: productId,
					ItemName: productName,
					Qty: quantity,
					Rate: rate,
					variantId,
					addonId,
					VariantName: variantName,
					addonName,
				} = item;

				return {
					productId,
					productName,
					quantity,
					rate,
					...(variantId && { variantName, varientId: variantId }),
					...(addonId && { addonName, addonId }),
				};
			});

			let selectedItemsPrev = [];

			let selectedAddonPrev = [];

			transformedData.forEach((item) => {
				if (item.addonId) {
					if (item.varientId) {
						const key = `${item.productId}_${item.varientId}`;
						selectedAddonPrev.push({ [key]: item });
					} else {
						const key = item.productId;
						selectedAddonPrev.push({ [key]: item });
					}
				} else {
					// Otherwise, it's a normal product
					selectedItemsPrev.push(item);
				}
			});

			const combinedItems = Object.values(
				selectedItemsPrev.reduce((acc, item) => {
					const key = `${item.productId}-${item.varientId}`;
					if (!acc[key]) {
						acc[key] = { ...item }; // Create a new entry if not exists
					} else {
						acc[key].quantity += item.quantity; // Add quantity if entry exists
					}
					return acc;
				}, {})
			);

			const groupedAddons = Object.values(selectedAddonPrev).reduce(
				(acc, curr) => {
					const key = Object.keys(curr)[0];
					if (acc[key]) {
						acc[key].push(curr[key]); // If key exists, push into the array
					} else {
						acc[key] = [curr[key]]; // If key doesn't exist, create a new array
					}
					return acc;
				},
				{}
			);

			// //("selectedAddonPrev",selectedAddonPrev);

			// Merging logic for nested array
			const mergedAddonData = Object.keys(groupedAddons).reduce((acc, key) => {
				acc[key] = Object.values(
					groupedAddons[key].reduce((addonAcc, addonItem) => {
						const addonKey = `${addonItem.addonId}`;
						if (!addonAcc[addonKey]) {
							addonAcc[addonKey] = { ...addonItem }; // Add new entry
						} else {
							addonAcc[addonKey].quantity += addonItem.quantity; // Merge quantities
						}
						return addonAcc;
					}, {})
				);
				return acc;
			}, {});

			setPreviousSelectedItemsToBill(combinedItems);
			// setPreviousSelectedAddons(groupedAddons)

			const addonsToIncludeInPrint = [];

			for (const key in mergedAddonData) {
				if (Array.isArray(mergedAddonData[key])) {
					mergedAddonData[key].forEach((item) => {
						const existingItem = addonsToIncludeInPrint.find(
							(combinedItem) => combinedItem.addonId === item.addonId
						);

						if (existingItem) {
							// Add the quantity if the item already exists
							existingItem.quantity += item.quantity;
						} else {
							// Add the item to the array if it's not already present
							addonsToIncludeInPrint.push({
								...item,
							});
						}
					});
				}
			}

			setToIncludeAddonsToPrint(addonsToIncludeInPrint);

			// imp.,............................................................................

			prevTotal = previousOrders.reduce(
				(total, order) => total + order.Qty * order.Rate,
				0
			);
		}

		const itemsTotal = selectedItems.reduce(
			(sum, item) => sum + item.quantity * (item.variantRate || item.rate),
			0
		);

		// Calculate total from addonsToViewFromSelectedAddon
		const addonsTotal = Object.values(addonsToViewFromSelectedAddon).reduce(
			(sum, addons) => {
				// `addons` is an array, so sum up quantity * rate for each addon
				return (
					sum +
					addons.reduce(
						(addonSum, addon) => addonSum + addon.quantity * addon.rate,
						0
					)
				);
			},
			0
		);

		setPrevOrderTotal(prevTotal);

		// Combine both totals
		let combinedTotal = prevTotal + itemsTotal + addonsTotal;

		// Calculate Discount
		const dAmt = combinedTotal * (discount / 100);
		setDiscountAmt(dAmt);
		combinedTotal -= dAmt;

		setTotal(combinedTotal.toFixed(2));
		setTotalValue(combinedTotal.toFixed(2));
		setIsBillAmountAdded(false);
		setAddedBillAdjustments(null);
	};

	const [foodType, setFoodType] = useState([]);

	// //(foodType);
	// const CancelOrder = async() => {
	//     const yes = window.confirm( 'Delete this item?' )
	//     console.log("setPreviousOrders\n",
	//         setPreviousOrders,"\n", billNo)
	//     if (yes){
	//         const response = await fetch(`${api_base_url}/deleteOrder/${logginedDB}/${billNo}`, {
	//             method: 'DELETE'
	//         });
	//         if (response.ok) {
	//             console.log("Bill deleted successfully");
	//             // const data = await response.json()
	//             // console.log("api success");
	//         }
	//     } else {
	//         console.log("not deleted")
	//     }
	// }

	// const CancelOrder = async () => {
	// 	const yes = window.confirm("Delete this item?");
	// 	console.log(billNo);
	// 	if (yes) {
	// 		try {
	// 			const response = await fetch(
	// 				`${api_base_url}/cancelOrder/${logginedDB}/${billNo}`,
	// 				{
	// 					method: "PUT", // Using DELETE method is more appropriate for deletion
	// 				}
	// 			);

	// 			if (response.ok) {
	// 				const data = await response.json();
	// 				console.log("Order deleted successfully", data);
	// 				// window.location.reload()
	// 				navigate("/TableView");
	// 				// You might want to update your UI state here
	// 			} else {
	// 				console.error("Failed to delete order");
	// 			}
	// 		} catch (error) {
	// 			console.error("Error deleting order:", error);
	// 		}
	// 	} else {
	// 		console.log("Deletion cancelled");
	// 	}
	// };

	const CancelOrder = async () => {
		if (!hasPermission('cancelKOT')) {
			alert("You do not have permission to cancel KOT / orders!");
			return;
		}
		const yes = window.confirm("Are you sure you want to cancel this order?");
		console.log("Cancelling bill:", billNo);

		if (yes) {
			// let selectedItemsWithAddons = [
			// 			...selectedItems
			// 		];

			// 	console.log("selectedItemsWithAddons",selectedItemsWithAddons);
			try {
				// Get additional info if needed (table number, etc.)
				const orderData = {
					// tableNo: currentTable, // Add this from your state
					// floor: currentFloor,   // Add this from your state
					// customerId: customerId // If available
				};

				const response = await fetch(
					`${api_base_url}/cancelOrder/${logginedDB}/${billNo}`,
					{
						method: "PUT",
						headers: {
							'Content-Type': 'application/json',
						},
						// body: JSON.stringify(orderData) // Send additional data
					}
				);

				if (response.ok) {
					const data = await response.json();
					console.log("Order cancelled successfully", data);

					// Show success message
					alert("Order has been cancelled successfully!");

					// Navigate back to table view
					navigate("/TableView");

					// You might also want to refresh the table view data
					// or emit a socket event to update other clients
				} else {
					const errorData = await response.json();
					console.error("Failed to cancel order:", errorData);
					alert(`Failed to cancel order: ${errorData.message || 'Unknown error'}`);
				}
			} catch (error) {
				console.error("Error cancelling order:", error);
				alert("Error cancelling order. Please try again.");
			}
		} else {
			console.log("Order cancellation cancelled");
		}
	};

	const handleGetFoodTypes = async () => {
		try {
			const response = await fetch(
				`${api_base_url}/getFoodType/${logginedDB}`,
				{
					method: "GET",
				}
			);

			if (response.status === 200) {
				const data = await response.json();
				setFoodType(data);
			} else {
			}
		} catch (error) {
			console.error("Fetch Error:", error);
		}
	};

	useEffect(() => {
		handleSetTotalOnRender();
		handleGetFoodTypes();
	}, [
		previousOrders,
		selectedItems,
		addonsToViewFromSelectedAddon,
		api_base_url,
		logginedDB,
		genSettings,
		taxGroups,
		discount
	]);

	const [editMode, setEditMode] = useState(true);

	const handleGetRunningOrders = async () => {
		try {
			const url = billNo
				? `${api_base_url}/getRunningOrders/${logginedDB}/${kotTableNo}/${kotAreaId}?billNo=${billNo}`
				: `${api_base_url}/getRunningOrders/${logginedDB}/${kotTableNo}/${kotAreaId}`;
			const response = await axios.get(url);
			if (response.status === 200) {
				if (response.data.noData) {
					return setPreviousOrders([]);
				}

				// const transformedData = response.data.particulars.map((item) => {
				//     const {
				//         Itemid: productId,
				//         ItemName: productName,
				//         Qty: quantity,
				//         Rate: rate,
				//         variantId,
				//         VariantName: variantName,
				//     } = item;

				//     return {
				//         productId,
				//         productName,
				//         quantity,
				//         ...(variantId ? { variantName, variantRate: rate, varientId: variantId } : { rate }),
				//     };
				// });

				if (response.data.customer) {
					const {
						mobile,
						name,
						address: addr,
						locality: loc,
						due,
					} = response.data.customer;

					const formattedCustomer = {
						mobile,
						name,
						addr,
						loc,
						due,
					};

					// console.log('formattedCustomer',formattedCustomer);

					setCustomerDetails(formattedCustomer);
				}

				setCustomerDetails((prev) => ({
					...prev,
					persons: response.data.persons,
				}));

				setBillNo(response.data.billNo);
				setPreviousOrders(response.data.particulars);
			}
		} catch (error) {
			console.error(error);
		}
	};

	// //(area_id_, tableNo_);

	// Memoize the function to avoid unnecessary re-renders
	// const fetchOrders = useCallback(() => {
	//     handleGetRunningOrders();
	// }, []);

	useEffect(() => {
		if ((area_id_ && tableNo_) || isDirectOrder) {
			handleGetRunningOrders();
		}
	}, [tableNo_, area_id_, for_, kotTableNo, kotAreaId, isDirectOrder]);


	const handleHoldOrders = async () => {
		if (selectedItems.length === 0) {
			return alert("No items seleted to hold!");
		}

		// Calculate the total from selectedItems
		const total = selectedItems.reduce(
			(sum, item) => sum + item.quantity * (item.variantRate || item.rate),
			0
		);

		// Merge selectedItems into holdInfo
		const updatedHoldInfo = {
			...holdInfo,
			total: total,
			selectedItems: [...selectedItems], // Add selectedItems as a key
		};

		try {
			const response = await axios.post(
				`${api_base_url}/holdOrders/${logginedDB}`,
				updatedHoldInfo
			);
			if (response.status == 200) {
				setHoldLoadOrderFunc(null);
				setSelectedItems([]);
				setAlreadySelectedVariants([]);
				setHoldInfo({});
				setClearLoadOrderFunc(false);
				toast.success(`Order has been holded!`, {
					className: "custom-toast",
					bodyClassName: "custom-toast-container",
					closeButtonClassName: "custom-toast-close-button",
					onClose: () => { },
				});
			}
		} catch (error) {
			//(error);
		}
	};

	const handleLoadOrders = async (holdNo) => {
		try {
			const response = await axios.get(
				`${api_base_url}/loadOrders/${logginedDB}/${holdNo}`
			);
			if (response.status === 200) {
				const transformedData = response.data.particulars.map((item) => {
					const {
						itemId: productId,
						ItemName: productName,
						Qty: quantity,
						Rate: rate,
						variantId,
						VariantName: variantName,
					} = item;

					return {
						productId,
						productName,
						quantity,
						...(variantId
							? { variantName, variantRate: rate, varientId: variantId }
							: { rate }),
					};
				});

				// Generate state for productId to variantIds mapping
				const productVariantsMap = response.data.particulars.reduce(
					(acc, item) => {
						const { itemId: productId, variantId } = item;
						if (!acc[productId]) {
							acc[productId] = [];
						}
						if (variantId) {
							acc[productId].push(variantId);
						}
						return acc;
					},
					{}
				);

				const transformedInformation = () => {
					const {
						PAdd1: add1,
						PAdd2: add2,
						mob,
						note,
						partyname: partyName,
					} = response.data.information;

					return {
						add1,
						add2,
						mob,
						note,
						partyName,
					};
				};
				setClearLoadOrderFunc(true);
				setHoldInfo(transformedInformation);
				setSelectedItems(transformedData);
				setAlreadySelectedVariants(productVariantsMap);
				setHoldLoadOrderFunc(null);
				handleRemoveOrders(holdNo);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleRemoveOrders = async (holdNo) => {
		try {
			const response = await axios.delete(
				`${api_base_url}/removeHoldOrders/${logginedDB}/${holdNo}`
			);
			if (response.status == 200) {
				// toast.success(`Order has been removed from holding!`, {
				//     className: 'custom-toast',
				//     bodyClassName: 'custom-toast-container',
				//     closeButtonClassName: 'custom-toast-close-button',
				//     onClose: () => { }
				// })
			}
		} catch (error) {
			//(error);
		}
	};

	const handleRemoveRunningItem = () => { };

	const handleRemoveRunningItemAddon = () => { };

	const [showUserInfo, setShowUserInfo] = useState(false);
	const [showGroup, setShowGroup] = useState(false);

	const [customerDetails, setCustomerDetails] = useState({});

	const [customerNumbers, setCustomerNumbers] = useState([]);

	// console.log('customerNumbers',customerNumbers);

	const handleGetCustomerMobile = async (val) => {
		// //("hi");

		try {
			const response = await axios.get(
				`${api_base_url}/getCustomerMobile/${val}/${logginedDB}`
			);
			if (response.status == 200) {
				setCustomerNumbers(response.data);
			}
		} catch (error) {
			//(error);
		}
	};

	const [selectedIndex, setSelectedIndex] = useState(-1);
	const dropdownRef = useRef(null);
	const inputRef = useRef(null);
	const locRef = useRef(null);
	const addrRef = useRef(null);
	const nameRef = useRef(null);

	const handleChangeInfo = (e, field) => {
		let val = e.target.value;

		if (field === "persons") {
			// Ensure the value does not exceed 5
			if (parseInt(val, 10) > totalPersons_) {
				val = totalPersons_;
			}
		}

		if (field === "mobile") {
			if (!val) {
				handleFocusMobile(val);
			} else {
				handleGetCustomerMobile(val);
			}
			setSelectedIndex(-1);
		} else {
		}
		setCustomerDetails((prev) => ({
			...prev,
			[field]: val,
		}));
	};

	const handleFocusMobile = async (val) => {
		// //("ppp");

		setSelectedIndex(-1);
		if (val && customerDetails.mobile) {
			handleGetCustomerMobile(customerDetails.mobile);
			return;
		}
		try {
			const response = await axios.get(
				`${api_base_url}/getAllCustomerMobile/${logginedDB}`
			);
			// //("hiiiiiiii");
			if (response.status === 200) {
				setCustomerNumbers(response.data);
			}
		} catch (error) {
			console.error("Failed to fetch customer numbers:", error);
		}
	};

	const handleBlurMobile = () => {
		setCustomerNumbers([]);
	};

	const handleKeyDown = (e) => {
		if (customerNumbers.length === 0) return;

		e.stopPropagation();

		if (e.key === "ArrowDown" || e.key === "ArrowUp") {
			e.preventDefault(); // Prevent number type input changes
		}

		if (e.key === "ArrowDown") {
			setSelectedIndex((prevIndex) =>
				prevIndex === customerNumbers.length - 1 ? 0 : prevIndex + 1
			);
		} else if (e.key === "ArrowUp") {
			setSelectedIndex((prevIndex) =>
				prevIndex <= 0 ? customerNumbers.length - 1 : prevIndex - 1
			);
		} else if (e.key === "Enter" && selectedIndex >= 0) {
			// Set state on Enter key press
			//   handleChangeInfo( customerNumbers[selectedIndex], 'mobile','keydown');
			setCustomerDetails((prev) => ({
				...prev,
				mobile: customerNumbers[selectedIndex].mobile,
				name: customerNumbers[selectedIndex].name,
				addr: customerNumbers[selectedIndex].address,
				loc: customerNumbers[selectedIndex].locality,
				due: customerNumbers[selectedIndex].due,
			}));
			setSelectedIndex(-1);
			setCustomerNumbers([]);
			if (nameRef.current) {
				nameRef.current.focus();
			}
		}
	};

	const handleClickMobile = (customer, e) => {
		e.stopPropagation();
		// //("Selected customer:", customer);
		// handleChangeInfo(customer, 'mobile','keydown');
		setCustomerDetails((prev) => ({
			...prev,
			mobile: customer.mobile,
			name: customer.name,
			addr: customer.address,
			loc: customer.locality,
			due: customer.due,
		}));
		setCustomerNumbers([]);
		setSelectedIndex(-1);
	};

	const handleWheel = (event) => {
		if (document.activeElement === inputRef.current) {
			event.preventDefault();
		}
	};

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.addEventListener("keydown", handleKeyDown);
			inputRef.current.addEventListener("wheel", handleWheel);
		}

		return () => {
			if (inputRef.current) {
				inputRef.current.removeEventListener("keydown", handleKeyDown);
				inputRef.current.removeEventListener("wheel", handleWheel);
			}
		};
	}, [selectedIndex, customerNumbers]);

	useEffect(() => {
		if (dropdownRef.current && selectedIndex >= 0) {
			const selectedElement = dropdownRef.current.children[selectedIndex];
			if (selectedElement) {
				selectedElement.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
				});
			}
		}
	}, [selectedIndex]);

	const printRef = useRef(null);

	function getCurrentDate() {
		const today = new Date();
		const day = String(today.getDate()).padStart(2, "0");
		const month = String(today.getMonth() + 1).padStart(2, "0"); // getMonth() is zero-based
		const year = today.getFullYear();
		return `${day}/${month}/${year}`;
	}

	function getCurrentTime() {
		const today = new Date();
		const hours = String(today.getHours()).padStart(2, "0");
		const minutes = String(today.getMinutes()).padStart(2, "0");
		return `${hours}:${minutes}`;
	}

	const removeItemMob = (productName, variantName = null) => {
		//(selectedItemInfo, "selectedItemInfo js");

		// Update `selectedItemInfo` to remove the product or variant
		setSelectedItemInfo((prevSelectedItemInfo) => {
			const updatedSelectedItemInfo = { ...prevSelectedItemInfo };

			if (updatedSelectedItemInfo[productName]) {
				if (variantName) {
					// Remove the specific variant
					delete updatedSelectedItemInfo[productName][variantName];

					// If no variants remain, remove the product entirely
					if (Object.keys(updatedSelectedItemInfo[productName]).length === 0) {
						delete updatedSelectedItemInfo[productName];
					}
				} else {
					// Remove the entire product
					delete updatedSelectedItemInfo[productName];
				}
			}

			return updatedSelectedItemInfo;
		});

		// Update `clickedItems` to remove the product if it's fully removed
		setClickedItems((prevClickedItems) =>
			prevClickedItems.filter((item) => item !== productName)
		);

		//(`Removed ${variantName ? variantName : productName}`);
	};

	const handleSplitBill = () => {
		if (!hasPermission('moveTable')) {
			alert("You do not have permission to split bills / move tables!");
			return;
		}
		if (!billNo || previousOrders.length === 0) {
			alert("No active bill/running order found on this table to split!");
			return;
		}
		setSplitBillState(true);
	};

	const [splitTableState, setSplitTableState] = useState(false);

	const [mergeTableState, setMergeTableState] = useState(false);

	const [meragableTables, setMeragableTables] = useState([]);

	const handleGetTablesToMerge = async () => {
		if (!hasPermission('moveTable')) {
			alert("You do not have permission to move / merge tables!");
			return;
		}
		try {
			const response = await axios.get(
				`${api_base_url}/getTableToMerge/${area_id_}/${for_}/${logginedDB}`
			);
			if (response.status == 200) {
				const data = response.data;
				if (data.length > 0) {
					setMergeTableState(true);
					setMeragableTables(data);
				} else {
					setMergeTableState(false);
					alert("No table found to merge!");
				}
			}
		} catch (error) {
			//(error);
		}
	};

	const [isCheckedAll, setIsCheckedAll] = useState(false);

	const [selectedTables, setSelectedTables] = useState([]);

	// console.log(selectedTables,'selectedTables');

	const [selectedTableNames, setSelectedTableNames] = useState([]);

	const [selectedTableCapacities, setSelectedTableCapacities] = useState([]);

	// console.log('selectedTables',selectedTables);
	// console.log('selectedTableNames',selectedTableNames);
	// console.log('selectedTableCapacities',selectedTableCapacities);

	const handleResetMerging = () => {
		if (selectedTables.length === 0) {
			setTableName_(location.state.tableName);
			setPersons_(location.state.persons);
		}
	};

	useEffect(() => {
		handleResetMerging();
	}, [location]);

	const [checkedTable, setCheckedTable] = useState(
		meragableTables.map(() => false) // Initialize all as unchecked
	);

	const handleIsCheckedAll = (e) => {
		const checked = e.target.checked;
		setIsCheckedAll(checked);
		setCheckedTable(meragableTables.map(() => checked)); // Set all checkboxes to the same state

		// Update selectedUsers with all or none
		if (checked) {
			setSelectedTables(meragableTables.map((table) => table.Table_id)); // Add all user ids
			setSelectedTableNames(
				meragableTables.map((table) => table.Table_onlineName)
			); // Add all tablenames
			setSelectedTableCapacities(
				meragableTables.map((table) => table.Table_Capacity)
			); // Add all tabelcapacities
		} else {
			setSelectedTables([]);
			setSelectedTableNames([]);
			setSelectedTableCapacities([]);
		}
	};

	const handleIsChecked = (index, checked) => {
		const updatedChecked = [...checkedTable];
		updatedChecked[index] = checked;
		setCheckedTable(updatedChecked);

		// Update "Select All" state if not all items are selected
		const allChecked = updatedChecked.every((item) => item);
		setIsCheckedAll(allChecked);

		// Update selectedUsers based on checked state
		const updatedSelectedUsers = [...selectedTables];
		const userId = meragableTables[index].Table_id;

		const updatedSelectedTableNames = [...selectedTableNames];
		const tableNames = meragableTables[index].Table_onlineName;

		const updatedSelectedTableCapacities = [...selectedTableCapacities];
		const tableCapacities = meragableTables[index].Table_Capacity;

		if (checked) {
			// Add the user id if checked
			updatedSelectedUsers.push(userId);

			updatedSelectedTableNames.push(tableNames);

			updatedSelectedTableCapacities.push(tableCapacities);
		} else {
			// Remove the user id if unchecked
			const userIndex = updatedSelectedUsers.indexOf(userId);
			if (userIndex !== -1) {
				updatedSelectedUsers.splice(userIndex, 1);
			}

			// Remove the tableNames if unchecked
			const tableNamesIndex = updatedSelectedTableNames.indexOf(tableNames);
			if (tableNamesIndex !== -1) {
				updatedSelectedTableNames.splice(tableNamesIndex, 1);
			}

			// Remove the tableCapacities if unchecked
			const tableCapacitiesIndex =
				updatedSelectedTableCapacities.indexOf(tableCapacities);
			if (tableCapacitiesIndex !== -1) {
				const tableCapacitiesIndex =
					updatedSelectedTableCapacities.indexOf(tableCapacities);
				updatedSelectedTableCapacities.splice(tableCapacitiesIndex, 1);
			}
		}

		setSelectedTables(updatedSelectedUsers);

		setSelectedTableNames(updatedSelectedTableNames);

		setSelectedTableCapacities(updatedSelectedTableCapacities);
	};

	const [selectedTableForMerge, setSelectedTableForMerge] = useState([]);

	const [nameForMergedTable, setNameForMergedTable] = useState(false);

	// console.log('selectedTableForMerge',selectedTableForMerge);

	const [respectedTableIndex, setRespectedTableIndex] = useState();
	const [respectedTableId, setRespectedTableId] = useState();
	const [respectedTableName, setRespectedTableName] = useState();
	const [respectedTableCapacity, setRespectedTableCapacity] = useState();

	const handleMergeTable = async (index, tableId, name, capacity) => {
		if (!hasPermission('moveTable')) {
			alert("You do not have permission to move / merge tables!");
			return;
		}
		if (isRunningTable) {
			setMergeTableState(false);
			setNameForMergedTable(false);
			// setTableName_(newTableName)
			// setNewTableName('')
			customerDetails.persons = "";
			// setPersons_(totalPersons_)

			let tableIds = [];
			if (selectedTables.length > 0) {
				if (selectedTables.includes(for_)) {
					tableIds = [...selectedTables]; // Keep as is if for_ is already present
				} else {
					tableIds = [...selectedTables, for_]; // Add for_ if not present
				}
			} else {
				if (selectedTables.includes(for_)) {
					tableIds = [tableId];
				} else {
					tableIds = [tableId, for_];
				}
				const updatedChecked = [...checkedTable];
				updatedChecked[index] = true;
				setCheckedTable(updatedChecked);
				setSelectedTables((prevTables) => [...prevTables, tableId]);
			}
			setSelectedTableForMerge(tableIds);

			let tableCapacities = [];
			if (selectedTableCapacities.length > 0) {
				if (selectedTableCapacities.includes(persons_)) {
					tableCapacities = [...selectedTableCapacities];
				} else {
					tableCapacities = [...selectedTableCapacities, persons_];
				}
			} else {
				if (selectedTableCapacities.includes(persons_)) {
					tableCapacities = [capacity];
				} else {
					tableCapacities = [capacity, persons_];
				}
			}

			const totalCapacity = tableCapacities.reduce((sum, val) => sum + val, 0);
			console.log("totalCapacity", totalCapacity);

			setTotalPersons_(totalCapacity);
		} else {
			setNameForMergedTable(true);

			setRespectedTableIndex(index);
			setRespectedTableId(tableId);
			setRespectedTableName(name);
			setRespectedTableCapacity(capacity);
		}
	};

	const [newTableName, setNewTableName] = useState("");

	// console.log('newTableName',newTableName)

	const [avail, setAvail] = useState(null);

	const handleCheckAvailableName = async (val) => {
		if (val === "") return setAvail(null);
		try {
			const response = await axios.get(
				`${api_base_url}/checkAvailableTableName/${val}/${logginedDB}`
			);
			if (response.status === 200) {
				const checked = response.data.isAvailable;
				if (checked == 0) {
					setAvail(1);
				} else {
					setAvail(0);
				}
			}
		} catch (error) {
			//(error);
		}
	};

	const [isValidMergedTables, setIsValidMergedTables] = useState(false);

	const [isRunningTable, setIsRunningTable] = useState(false);

	const handleCheckValidMergedTables = async () => {
		try {
			const response = await axios.get(
				`${api_base_url}/checkValidMergedTables/${for_}/${logginedDB}`
			);
			if (response.status === 200) {
				if (response.data.valid) {
					setIsValidMergedTables(true);
					setIsRunningTable(true);
				}
			}
		} catch (error) {
			//(error);
		}
	};

	useEffect(() => {
		if (for_) {
			if (billNo || previousOrders.length > 0) {
				setIsRunningTable(true);
			}
			// Only check mergedTables for real numeric table IDs â€” not delivery/pickup/parcel
			if (!isDirectOrder) {
				handleCheckValidMergedTables();
			}
		}
	}, [for_, billNo, previousOrders]);

	const handleOnChangeTableName = (e) => {
		e.stopPropagation();
		const val = e.target.value;
		setNewTableName(val);
		handleCheckAvailableName(val);
	};

	const handleSaveNameUpdate = () => {
		if (avail === 0 || !avail) {
			return alert("Duplicate name!");
		}
		setTableName_(newTableName);
		setUpdateTableName(false);
		setCustomerDetails((prev) => ({
			...prev,
			persons: newTableName,
		}));
	};

	const handleSaveMerging = (e) => {
		if (avail === 0 || !avail) {
			return alert("Duplicate name!");
		}
		e.stopPropagation();
		if (newTableName && newTableName !== "") {
			setMergeTableState(false);
			setNameForMergedTable(false);
			setTableName_(newTableName);
			// setNewTableName('')
			customerDetails.persons = "";
			// setPersons_(totalPersons_)

			let tableIds = [];
			if (selectedTables.length > 0) {
				if (selectedTables.includes(for_)) {
					tableIds = [...selectedTables]; // Keep as is if for_ is already present
				} else {
					tableIds = [...selectedTables, for_]; // Add for_ if not present
				}
			} else {
				if (selectedTables.includes(for_)) {
					tableIds = [respectedTableId];
				} else {
					tableIds = [respectedTableId, for_];
				}
				const updatedChecked = [...checkedTable];
				updatedChecked[respectedTableIndex] = true;
				setCheckedTable(updatedChecked);
				setSelectedTables((prevTables) => [...prevTables, respectedTableId]);
			}
			setSelectedTableForMerge(tableIds);

			// let tableNames = selectedTableNames.length > 0 ? [...selectedTableNames, tableName_] : [name, tableName_]
			// const tableInitials = tableNames.map(name => name.charAt(0).toUpperCase()).join('');
			// const areaPrefix = area_.substring(0, 3).toUpperCase();
			// const combinedName = `${areaPrefix}-${tableInitials}`;
			// setTableName_(combinedName)

			// console.log('selectedTableCapacities',selectedTableCapacities);

			let tableCapacities = [];
			if (selectedTableCapacities.length > 0) {
				if (selectedTableCapacities.includes(persons_)) {
					tableCapacities = [...selectedTableCapacities];
				} else {
					tableCapacities = [...selectedTableCapacities, persons_];
				}
			} else {
				if (selectedTableCapacities.includes(persons_)) {
					console.log("hiii", respectedTableCapacity);

					tableCapacities = [respectedTableCapacity];
				} else {
					console.log("helooo", respectedTableCapacity);

					tableCapacities = [respectedTableCapacity, persons_];
				}
			}

			// const tableCapacities = selectedTableCapacities.length > 0 ? [...selectedTableCapacities, persons_] : [respectedTableCapacity, persons_]
			// console.log('tableCapacities',tableCapacities);

			// console.log(tableCapacities,'tableCapacities');

			const totalCapacity = tableCapacities.reduce((sum, val) => sum + val, 0);
			setTotalPersons_(totalCapacity);
		} else {
			alert("Enter Table Name!");
		}
	};

	const handleOnReset = async () => {
		try {
			const response = await axios.get(
				`${api_base_url}/getTableDetails/${for_}/${logginedDB}`
			);
			if (response.status == 200) {
				const data = response.data[0];
				console.log("data", data);
				customerDetails.persons = "";
				setTotalPersons_(data.Table_Capacity);
				setTableName_(data.Table_onlineName);
				setMergeTableState(false);
				setNameForMergedTable(false);
				setCheckedTable(meragableTables.map(() => false));
				setSelectedTables([]);
				setSelectedTableForMerge([]);
				setIsCheckedAll(false);
				setSelectedTableCapacities([]);
			}
		} catch (error) {
			//(error);
		}
	};

	const [updateTableName, setUpdateTableName] = useState(false);

	return (
		<div className="w-screen h-screen overflow-hidden">
			<div className="w-full h-full hidden sm:flex sm:flex-col overflow-hidden">
				<div className="w-full h-max">
					<SherDineNav
						sideNav={(state) => handleSideNav(state)}
						falseState={falseState}
					/>
				</div>
				<div className="w-full bg-[#f5f5f5] flex-grow flex gap-3 overflow-hidden">
					<div className="w-max h-full z-[9999]">
						<SideNav
							focus={"Tables"}
							state={sideNav}
							falseState={(state) => setFalseState(state)}
						/>
					</div>
					<div className="flex flex-col w-full h-full overflow-hidden pr-3 pb-3 gap-3">
						<div className="w-full h-max bg-[#fff] borderBottom  overflow-hidden shadow-sm">
							<TopRootDiv image={"Tables"} root={["Tables"]} section={"KOT"} />
						</div>
						<div className="flex w-full h-full gap-3 relative overflow-hidden">
							{/* {previewPreviousOrders && (
                                <div className='absolute inset-0 bg-black bg-opacity-75 z-[7777]' onClick={() => setPreviewPreviousOrders(false)}></div>
                            )} */}
							<div className="w-full flex h-full flex-col gap-3 overflow-hidden">
								<div className="SearchItems_KOT h-max ">
									<div className="SearchItems_KOT_ImageDiv">
										<img src={Search} alt="?" />
									</div>
									<input
										className="SearchProducts"
										type="text"
										name="Search"
										placeholder="Search..."
										value={searchInput}
										onChange={(e) => handleSearchItem(e)}
									/>
								</div>

								<div className="flex w-full h-full gap-2 overflow-hidden">

									<div className="min-w-max h-full flex flex-col bg-[#465366] overflow-y-auto customScroll">
										{/* All Button */}
										<div
											className={`w-full flex justify-start items-center text-[1rem] font-[500] px-5 py-4 font-nunito text-[#fff] cursor-pointer ${activeCategory === "all"
												? "bg-[#2591D1]"
												: "bg-[#465366]"
												}`}
											onClick={() => handleCategoryClick("all")}
										>
											<span className="w-[5rem] truncate">All</span>
										</div>

										{/* Category Buttons */}
										{categories.map((CateData, index) => (
											<div
												key={index}
												className={`w-full flex justify-start items-center text-[1rem] font-[500] px-5 py-4 font-nunito text-[#fff] cursor-pointer ${activeCategory === CateData.id_category
													? "bg-[#2591D1]"
													: "bg-[#465366]"
													}`}
												onClick={() =>
													handleCategoryClick(CateData.id_category)
												}
											>
												<span className="w-[5rem] truncate">
													{CateData.Category_Name}
												</span>
											</div>
										))}
									</div>

									<div className="w-full h-full text-[.9rem] font-nunito font-[500] pr-2 overflow-y-auto customScroll">
										{activeCategory && filteredProducts.length > 0 ? (
											<div className="w-full grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-2">
												{(searchInput ? filteredItemsDesktop : filteredProducts)
													.length > 0 ? (
													(searchInput
														? filteredItemsDesktop
														: filteredProducts
													).map((ProData, index) => {
														const hasVariant = ProData.varients.length > 0;
														const rate = hasVariant
															? Math.min(
																...ProData.varients.map(
																	(variant) => variant.variantRate
																)
															)
															: ProData.rate;

														const tracking = getProductTrackingInfo(ProData);
														const isTracked = tracking.isTracked;
														const isSoldOut = tracking.isSoldOut;
														const isLowStock = tracking.isLowStock;

														return (
															<div
																className={`shadow-md flex flex-col justify-center items-center bg-white rounded-t-[.313rem] relative cursor-pointer overflow-hidden ${isSoldOut ? "opacity-45 cursor-not-allowed filter grayscale" : ""}`}
																key={index}
																onClick={() => {
																	if (isSoldOut) {
																		Swal.fire({
																			icon: 'error',
																			title: 'Sold Out',
																			text: `${ProData.productName} is sold out today!`,
																			confirmButtonColor: '#0008B4'
																		});
																		return;
																	}
																	handleItemClick(ProData);
																}}
															>
																{isTracked && (
																	<div className="absolute top-2 left-2 z-[10] px-2 py-0.5 rounded text-[0.7rem] font-bold text-white shadow-sm"
																		style={{
																			background: isSoldOut ? '#ef4444' : isLowStock ? '#f59e0b' : '#10b981'
																		}}
																	>
																		{isSoldOut ? 'Sold Out' : `${tracking.available_qty} Left`}
																	</div>
																)}
																<div className="w-full h-[7rem] flex justify-center items-center object-cover">
																	<img
																		className="w-full h-full object-cover rounded-t-[.31rem] transform transition duration-300 ease-in-out"
																		src={
																			ProData.imageBase64
																				? ProData.imageBase64
																				: noImage
																		}
																		alt=""
																	/>
																</div>
																<div className="h-max relative flex justify-center items-center font-[500] text-[1rem] w-full px-3 py-1 text-wrap text-[#000]">
																	<span className="w-full text-center">
																		{ProData.productName}
																	</span>
																	<div className="w-max absolute right-1 flex justify-center items-center">
																		<img
																			src={
																				foodType.find(
																					(type) =>
																						type.FoodType_id ===
																						ProData.foodType
																				)?.FoodType_name === "Veg"
																					? Veg
																					: NonVeg
																			}
																			alt="?"
																			className="w-[1rem]"
																		/>
																	</div>
																</div>
																<div className="h-max font-[500] flex justify-center items-center text-[1rem] w-full px-3 py-1 text-wrap text-[#fff] bg-[#465366]">
																	{"\u20B9"} {rate.toFixed(2)}
																</div>
															</div>
														);
													})
												) : (
													<div>No Item!</div>
												)}
											</div>
										) : (
											<div>No Product is Registered</div>
										)}
									</div>
								</div>
							</div>
							<div className="w-[36rem] bg-white shadow-sm border border-gray-200 rounded-md flex flex-col h-full overflow-hidden relative z-10">
								<div className="w-full flex flex-col gap-1">
									<div className="w-full h-max flex text-[1rem] font-[600] font-nunito text-center rounded-t-[.313rem] text-nowrap gap-[.1rem] bg-[#fff]">
										<div
											className={`w-1/2 py-1 rounded-tl-[.313rem] cursor-pointer ${for_ &&
												for_ !== "delivery" &&
												for_ !== "pickup" &&
												for_ !== "parcel" &&
												for_ !== "reserve"
												? "bg-[#0008B4] text-[#fff]"
												: "bg-[#eaeaea] text-[#000] hover:bg-[#e2e2e2]"
												}`}
											onClick={handleDineIn}
										>
											DINE IN
										</div>
										{for_ && for_ === "delivery" ? (
											<div
												className="w-1/2 py-1 rounded-tr-[.313rem] cursor-pointer bg-[#0008B4] text-[#fff]"
												onClick={() => {
													setFor_("delivery");
													setDineType("delivery");
													setPreviousOrdersFunc([]);
												}}
											>
												DELIVERY
											</div>
										) : for_ && for_ === "pickup" ? (
											<div
												className="w-1/2 py-1 rounded-tr-[.313rem] cursor-pointer bg-[#0008B4] text-[#fff]"
												onClick={() => {
													setFor_("pickup");
													setDineType("pickup");
													setPreviousOrdersFunc([]);
												}}
											>
												PICKUP
											</div>
										) : for_ && for_ === "parcel" ? (
											<div
												className="w-1/2 py-1 rounded-tr-[.313rem] cursor-pointer bg-[#0008B4] text-[#fff]"
												onClick={() => {
													setFor_("parcel");
													setDineType("parcel");
													setPreviousOrdersFunc([]);
												}}
											>
												PARCEL
											</div>
										) : (
											<div
												className={`w-1/2 py-1 rounded-tr-[.313rem] cursor-pointer ${for_ && for_ === "reserve"
													? "bg-[#0008B4] text-[#fff]"
													: "bg-[#eaeaea] text-[#000] hover:bg-[#e2e2e2]"
													}`}
												onClick={() => {
													setFor_("reserve");
													setPreviousOrdersFunc([]);
												}}
											>
												RESERVE
											</div>
										)}
									</div>
									<div className="w-full flex flex-col font-nunito">
										<div
											className={`w-full h-max flex bg-[#fff] ${showUserInfo ||
												showGroup ||
												updateTableName ||
												splitTableState ||
												showPaymentInfo
												? "border-b"
												: ""
												}`}
										>
											<div
												className={`w-max flex justify-center items-center text-nowrap gap-2 px-[.75rem] py-2 
													border-r cursor-pointer hover:bg-[#e7e7e7] ${updateTableName ? "bg-[#e7e7e7]" : ""
													}`}
												onClick={() => {
													if (
														selectedTableForMerge.length > 0 &&
														!isRunningTable
													) {
														setShowGroup(false);
														setShowPaymentInfo(false);
														setMergeTableState(false);
														setSplitTableState(false);
														setShowUserInfo(false);
														setUpdateTableName((a) => !a);
													}
												}}
											>
												<img className="w-[1.25rem]" src={Roundtable} alt="" />
												{/* <span className='opacity-75 h-[1.25rem]'>{areaCode_}{tableNo_}</span> */}
												<span className="opacity-75 h-[1.25rem]">
													{tableName_}
												</span>
											</div>
											<div
												className={`w-max flex justify-center items-center px-[.75rem] py-2 border-r cursor-pointer hover:bg-[#e7e7e7] ${showUserInfo ? "bg-[#e7e7e7]" : ""
													}`}
												onClick={() => {
													setShowGroup(false);
													setShowPaymentInfo(false);
													setMergeTableState(false);
													setSplitTableState(false);
													setUpdateTableName(false);
													setShowUserInfo((a) => !a);
												}}
											>
												<img className="w-[1.25rem]" src={UserD} alt="" />
											</div>
											<div
												className={`w-max flex justify-center items-center px-[.75rem] py-2 border-r cursor-pointer hover:bg-[#e7e7e7] ${showGroup ? "bg-[#e7e7e7]" : ""
													}`}
												onClick={() => {
													setShowUserInfo(false);
													setShowPaymentInfo(false);
													setMergeTableState(false);
													setSplitTableState(false);
													setUpdateTableName(false);
													setShowGroup((a) => !a);
												}}
											>
												<img className="w-[1.5rem]" src={GroupD} alt="" />
											</div>
											{/* <div
												className={`w-max flex justify-center items-center px-[.75rem] py-2 border-r cursor-pointer hover:bg-[#e7e7e7] ${splitTableState ? "bg-[#e7e7e7]" : ""
													}`}
												onClick={() => {
													if (!hasPermission('moveTable')) {
														alert("You do not have permission to move / split tables!");
														return;
													}
													setShowUserInfo(false);
													setShowGroup(false);
													setShowPaymentInfo(false);
													setMergeTableState(false);
													setUpdateTableName(false);
													setSplitTableState(true);
												}}
											>
												{/* <span className='text-[.75rem]'>Split</span> * /}
												{/* <span className='text-[.75rem]'>table</span> * /}
												<img
													className="w-[1.5rem] opacity-75"
													src={split}
													alt=""
												/>
											</div> */}
											<div
												className={`w-max flex justify-center items-center px-[.75rem] py-2 border-r cursor-pointer hover:bg-[#e7e7e7] ${mergeTableState ? "bg-[#e7e7e7]" : ""
													}`}
												onClick={() => {
													setShowUserInfo(false);
													setShowGroup(false);
													setShowPaymentInfo(false);
													setSplitTableState(false);
													setUpdateTableName(false);
													handleGetTablesToMerge();
												}}
											>
												{/* <span className='text-[.75rem]'>Merge</span> */}
												{/* <span className='text-[.75rem]'>table</span> */}
												<img
													className="w-[1.5rem] opacity-75"
													src={merge}
													alt=""
												/>
											</div>
											{payments && payments.cash !== prevOrderTotal && (
												<div
													className={`w-max flex justify-center items-center px-[.75rem] py-2 border-l cursor-pointer hover:bg-[#e7e7e7] ${showPaymentInfo ? "bg-[#e7e7e7]" : ""
														}`}
													onClick={() => {
														setShowUserInfo(false);
														setShowGroup(false);
														setMergeTableState(false);
														setSplitTableState(false);
														setUpdateTableName(false);
														setShowPaymentInfo((a) => !a);
													}}
												>
													<img
														className="w-[1.25rem] opacity-75"
														src={info}
														alt=""
													/>
												</div>
											)}
											<div
												className={`w-max flex justify-center items-center px-[.75rem] py-2 cursor-pointer hover:bg-[#e7e7e7]`}>
												<button onClick={CancelOrder} style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}>Cancel Order</button>
											</div>
										</div>
										{showUserInfo && (
											<div className="w-full flex flex-col gap-2 text-[.9rem] text-left bg-[#fff] text-[#5c5c5c] p-2">
												<div className="w-full flex justify-start items-center gap-2">
													<div className="w-1/4">
														<span className="">Mobile:</span>
													</div>
													<div className="relative w-3/4">
														<div className="w-full flex gap-2">
															<input
																type="number"
																className={`p-1 rounded-[.313rem] border text-left ${customerDetails.due ? "w-3/5" : "w-full"
																	}`}
																ref={inputRef}
																value={customerDetails.mobile || ""}
																onFocus={() => handleFocusMobile("focus")}
																onBlur={handleBlurMobile}
																onChange={(e) => handleChangeInfo(e, "mobile")}
															/>
															{customerDetails.due && (
																<div className="w-2/5 flex justify-center pl-1 items-center rounded-[.313rem] border bg-[#f0efef]">
																	<span>Due:</span>
																	<input
																		className="w-full p-1 border-none text-right bg-transparent"
																		type="text"
																		disabled
																		value={`\u20B9 ${customerDetails.due}`}
																	/>
																</div>
															)}
														</div>
														{customerNumbers.length > 0 && (
															<div
																className="absolute transform translate-x-0 translate-y-0 w-full p-[2px] gap-[2px] min-h-0 z-[9999] max-h-[7rem] overflow-auto customScrollSelect flex flex-col border bg-[#fff] text-[.85rem] rounded-[.313rem] mt-1"
																ref={dropdownRef}
															>
																{customerNumbers.map((customer, index) => (
																	<div
																		key={index}
																		className={`w-full pb-[2px] text-[#000] cursor-pointer ${selectedIndex === index
																			? "bg-[#eaeaea]"
																			: "bg-[#f4f4f4]"
																			}`}
																		onMouseEnter={() => setSelectedIndex(index)}
																		onMouseDown={(e) =>
																			handleClickMobile(customer, e)
																		}
																	>
																		<div className="p-1 text-nowrap overflow-x-auto noScroll font-sans">
																			{customer.mobile}
																			{customer.address || customer.locality
																				? ` - ${customer.address}, ${customer.locality}`
																				: ""}
																		</div>
																	</div>
																))}
															</div>
														)}
													</div>
												</div>
												<div className="w-full flex justify-start items-center gap-2">
													<span className="w-1/4">Name:</span>
													<input
														type="text"
														className="p-1 border w-3/4 rounded-[.313rem] text-[.9rem]"
														ref={nameRef}
														value={customerDetails.name || ""}
														onKeyDown={(e) => {
															if (e.key === "Enter") {
																addrRef.current.focus();
															}
														}}
														onChange={(e) => handleChangeInfo(e, "name")}
													/>
												</div>
												<div className="w-full flex justify-start items-center gap-2">
													<span className="w-1/4">Address:</span>
													<input
														type="text"
														className="p-1 rounded-[.313rem] border w-3/4 text-[.9rem]"
														ref={addrRef}
														value={customerDetails.addr || ""}
														onKeyDown={(e) => {
															if (e.key === "Enter") {
																locRef.current.focus();
															}
														}}
														onChange={(e) => handleChangeInfo(e, "addr")}
													/>
												</div>
												<div className="w-full flex justify-start items-center gap-2">
													<span className="w-1/4">Locality:</span>
													<input
														type="text"
														className="p-1 rounded-[.313rem] border w-3/4 text-[.9rem]"
														ref={locRef}
														value={customerDetails.loc || ""}
														onChange={(e) => handleChangeInfo(e, "loc")}
													/>
												</div>
												<div className="w-full flex justify-end items-center gap-1">
													<div className="w-1/5 flex justify-center pl-1 items-center rounded-[.313rem] border bg-[rgba(17,0,255,0.98)]">
														<button
															className="text-white"
															onClick={() => handleSaveCustomer()}
															disabled={isSaving}
														>
															{isSaving ? 'Saving...' : 'Save'}
														</button>
													</div>
												</div>
											</div>
										)}
										{showGroup && (
											<div className="w-full flex flex-col gap-2 text-[.9rem] text-left bg-[#fff] text-[#5c5c5c] p-2">
												<div className="w-full flex justify-start items-center gap-2">
													<span className="w-max text-nowrap">
														No of Persons:
													</span>
													<input
														type="number"
														className="p-1 border min-w-0 max-w-max rounded-[.313rem] text-[.9rem] text-left"
														value={customerDetails.persons || ""}
														onChange={(e) => handleChangeInfo(e, "persons")}
													/>
												</div>
											</div>
										)}
										{showPaymentInfo && (
											<div className="w-full flex gap-2 text-[.85rem] text-left bg-[#465366] text-[#e8e8e8] p-2">
												<div className="w-max flex justify-center items-start">
													<img
														className="w-[1.25rem] invert"
														src={comment}
														alt=""
													/>
												</div>
												<div className="w-full flex flex-col text-left">
													<span className="w-full font-semibold ">
														Part Payment Details
													</span>
													<div className="w-full flex flex-col">
														{payments &&
															Object.entries(payments)
																.filter(
																	([_, value]) => value !== "" && value !== 0
																) // Exclude empty string and 0 values
																.map(([key, value], index) => (
																	<span key={index} className="">
																		{key === "duepayment"
																			? `Due payment [${customerDetails.mobile}] of \u20B9${value}`
																			: `Pay via ${key} of \u20B9${value}`}
																	</span>
																))}
													</div>
												</div>
											</div>
										)}
										{updateTableName && (
											<div className="w-full flex flex-col gap-2 text-[.9rem] text-left bg-[#fff] text-[#5c5c5c] p-2">
												<div className="w-full flex justify-start items-center gap-2">
													<span className="w-max text-nowrap">Table Name:</span>
													<div className="w-full flex areaBorder rounded-[.313rem]">
														<input
															type="text"
															className="w-full text-[.9rem] text-left p-1 border-0"
															disabled={isRunningTable}
															value={newTableName || ""}
															onChange={handleOnChangeTableName}
														/>
														<div className="w-max flex justify-center items-center p-1">
															{avail == 1 && (
																<img
																	className="w-[1.25rem]"
																	src={tick}
																	alt=""
																/>
															)}
															{avail == 0 && (
																<img
																	className="w-[1.25rem]"
																	src={cross}
																	alt=""
																/>
															)}
														</div>
													</div>
													<button
														className="w-max p-1 bg-[#e7e7e7] rounded-[.313rem] border"
														onClick={handleSaveNameUpdate}
													>
														<img className="w-[2rem]" src={save} alt="" />
													</button>
												</div>
											</div>
										)}
									</div>
									<div>
										{!isVisible && (
											<div className="w-full h-max flex text-[.9rem] font-[500] font-nunito text-center text-[#fff] gap-[.1rem]">
												<div className="w-2/4 py-1 bg-[#465366]">Item</div>
												<div className="w-1/4 py-1 bg-[#465366]">Qty</div>
												<div className="w-1/4 py-1 bg-[#465366]">Price</div>
											</div>
										)}
									</div>
								</div>
								{isVisible ? (
									<div className="w-full h-full flex flex-col justify-end items-center bg-[#465366] relative overflow-y-auto customScroll">
										<div
											className="sticky top-0 h-max bg-[#fff] cursor-pointer flex justify-center items-center rounded-b-[.313rem] px-2"
											onClick={toggleVisibility}
										>
											<img className="w-[1rem]" src={Down} alt="?" />
										</div>
										<div className="w-full h-full bg-[#465366] flex flex-col p-2 gap-2 font-nunito text-[.9rem] font-[600]">
											<div className="w-full flex justify-center items-center border rounded-[.313rem] text-[#fff] px-2 py-1">
												<div className="w-3/4 ">Sub Total</div>
												<div
													className="w-1/4 flex justify-end items-center "
													ref={divRef}
												>
													<img
														className="w-[.9rem] invert"
														src={Rupee}
														alt="?"
													/>
													<span className="text-[1rem]">{total}</span>
												</div>
											</div>
											<div className="w-full flex justify-center items-center border rounded-[.313rem] text-[#fff] px-2 py-1">
												<div className="w-3/4 ">Discount (%)</div>
												<div className="w-1/4 flex justify-end items-center">
													<input
														className="w-full text-[#000] font-[500] px-2"
														type="number"
														value={discount}
														onChange={(e) => {
															const newDiscount = parseFloat(e.target.value) || 0;
															if (newDiscount > 0 && !hasPermission('allowDiscount')) {
																alert("You do not have permission to apply discounts!");
																return;
															}
															if (newDiscount > 15 && !hasPermission('allowSpecialDiscount')) {
																alert("Discounts above 15% require Special Discount permission!");
																return;
															}
															setDiscount(newDiscount);
														}}
													/>
												</div>
											</div>
											<div className="w-full flex justify-center items-center border rounded-[.313rem] text-[#fff] px-2 py-1">
												<div className="w-3/4 ">Delivery Charge</div>
												<div className="w-1/4 flex justify-end items-center">
													<input
														className="w-full text-[#000] font-[500] px-2"
														type="number"
														name="deliverycharge"
														inputMode="numeric"
														value={inputValueDeliveryCharge}
														onChange={(event) =>
															handleInputChange(
																event,
																setInputValueDeliveryCharge
															)
														}
													/>
												</div>
											</div>
											<div className="w-full flex justify-center items-center border rounded-[.313rem] text-[#fff] px-2 py-1">
												<div className="w-3/4 ">Container Charge</div>
												<div className="w-1/4 flex justify-end items-center">
													<input
														className="w-full text-[#000] font-[500] px-2"
														type="number"
														name="containercharge"
														inputMode="numeric"
														value={inputValueContainerCharge}
														onChange={(event) =>
															handleInputChange(
																event,
																setInputValueContainerCharge
															)
														}
													/>
												</div>
											</div>
											<div className="w-full flex justify-center items-center border rounded-[.313rem] text-[#fff] px-2 py-1">
												<div className="w-3/4 ">Tax</div>
												<div className="w-1/4 flex justify-end items-center"></div>
											</div>
											<div className="w-full flex justify-center items-center border rounded-[.313rem] text-[#fff] px-2 py-1">
												<div className="w-3/4 ">Round Off</div>
												<div className="w-1/4 flex justify-end items-center"></div>
											</div>
											<div className="w-full flex justify-center items-center border rounded-[.313rem] text-[#fff] px-2 py-1">
												<div className="w-3/4 ">Customer Paid</div>
												<div className="w-1/4 flex justify-end items-center">
													<input
														className="w-full text-[#000] font-[500] px-2"
														type="number"
														name="customerpaid"
														inputMode="numeric"
														value={inputValueCustomerPaid}
														onChange={(event) =>
															handleInputChange(
																event,
																setInputValueCustomerPaid
															)
														}
													/>
												</div>
											</div>
											<div className="w-full flex justify-center items-center border rounded-[.313rem] text-[#fff] px-2 py-1">
												<div className="w-3/4 ">
													{calculateCustomerBalance().balanceReturn > 0
														? "Return To Customer"
														: "Balance Due"}
												</div>
												<div className="w-1/4 flex justify-end items-center">
													{calculateCustomerBalance().balanceReturn > 0
														? calculateCustomerBalance().balanceReturn.toFixed(2)
														: calculateCustomerBalance().balanceDue.toFixed(2)}
												</div>
											</div>
											<div className="w-full flex justify-center items-center border rounded-[.313rem] text-[#fff] px-2 py-1">
												<div className="w-3/4 ">Tip</div>
												<div className="w-1/4 flex justify-end items-center">
													<input
														className="w-full text-[#000] font-[500] px-2"
														type="number"
														name="tip"
														inputMode="numeric"
														value={inputValueTip}
														onChange={(event) =>
															handleInputChange(event, setInputValueTip)
														}
													/>
												</div>
											</div>
											<button
												type="button"
												className={`w-full rounded-[.313rem] px-2 py-1 font-[700] ${isBillAmountAdded
														? "bg-[#2e7d32] text-[#fff]"
														: "bg-[#0008B4] text-[#fff]"
													}`}
												onClick={handleAddAmountsToBill}
											>
												{isBillAmountAdded ? "Added to Bill" : "Add to Bill"}
											</button>
										</div>
									</div>
								) : (
									<div className="relative w-full h-full bg-[#fff] flex flex-col font-nunito justify-end items-center overflow-hidden ">
										{/* <div className='sticky top-0 w-full h-max flex shadow-md p-1 text-[.9rem] font-[600] text-nowrap'>
                                            <span className='w-3/4'>Running order</span>
                                            <span className='w-1/4 flex justify-center items-center'>{"\u20B9"} 456</span>
                                        </div> */}
										{previousOrders.length > 0 &&
											(previewPreviousOrders ? (
												<div
													className="absolute top-0 left-0 bg-[#c30000] cursor-pointer w-max h-max flex shadow-[1px_1px_6px_rgba(0,0,0,0.5)] rounded-br-[.313rem] p-1 z-[8889]"
													onClick={() => {
														setPreviewPreviousOrders(false);
													}}
												>
													<img
														className="w-[1rem] invert"
														src={Cross1}
														alt=""
													/>
												</div>
											) : (
												<div
													className="sticky top-0 w-full h-max cursor-pointer flex shadow-md py-1 text-[.9rem] font-[600] text-nowrap runningorderBackground"
													onClick={() => {
														setPreviewPreviousOrders(true);
													}}
												>
													<span className="w-3/4 px-2">Running orders</span>
													<span className="w-1/4 flex justify-center items-center">
														{"\u20B9"} {prevOrderTotal}
													</span>
												</div>
											))}
										<div className="relative w-full h-full flex flex-col gap-3 py-3 overflow-y-auto customScroll">
											{selectedItems.map((item, index) => {
												const haveVarient = item?.varientId || null;
												const name = haveVarient
													? `${item.productName} ${item.variantName || ""}`
													: item.productName;
												const rate = haveVarient ? item.variantRate : item.rate;
												const totalPrice = item.quantity * rate;
												return (
													<div
														className="w-full flex flex-col py-1 text-[1.01rem] bg-[#F5F5F5]"
														key={index}
													>
														<div className="w-full flex flex-col">
															<div className="w-full flex">
																<div className="w-2/4 flex justify-start items-center py-1 px-2 gap-2">
																	<img
																		className="w-[1.15rem] cursor-pointer"
																		src={Cross}
																		alt=" ? "
																		onClick={() =>
																			removeItem(
																				item.productId,
																				haveVarient ? item.varientId : null
																			)
																		} // Adjust removal logic
																	/>
																	{name}
																</div>
																<div className="w-1/4 flex justify-center items-center p-1">
																	<div className="ListItemsSelected_ListItem1_Qty_Option flex px-2 justify-center items-center">
																		<div className="w-max flex justify-center items-center">
																			<img
																				className="w-[1rem] cursor-pointer"
																				src={Minus}
																				alt="?"
																				onClick={() =>
																					decrement(
																						item.productId,
																						haveVarient ? item.varientId : null
																					)
																				} // Adjust decrement logic
																			/>
																		</div>
																		<input
																			className="w-full border-none text-center bg-transparent"
																			type="number"
																			value={item.quantity || 1}
																			onFocus={(e) =>
																				handleFocusQtyInput(
																					e,
																					item.productId,
																					haveVarient ? item.varientId : null
																				)
																			}
																			onBlur={(e) =>
																				handleBlurQtyInput(
																					e,
																					item.productId,
																					haveVarient ? item.varientId : null
																				)
																			}
																			onChange={(e) =>
																				handleOnChangeQtyInput(
																					e,
																					item.productId,
																					haveVarient ? item.varientId : null
																				)
																			}
																		/>
																		<div className="w-max flex justify-center items-center">
																			<img
																				className="w-[1rem] cursor-pointer"
																				src={Plus}
																				alt="?"
																				onClick={() =>
																					increment(
																						item.productId,
																						haveVarient ? item.varientId : null
																					)
																				} // Adjust increment logic
																			/>
																		</div>
																	</div>
																</div>
																<div className="w-1/4 flex justify-center items-center p-1 font-[600] text-[1.05rem]">
																	<img className="Rupee" src={Rupee} alt="?" />
																	{totalPrice}
																</div>
															</div>
															{item.remarks && (
																<div className="w-full h-max flex justify-start items-center gap-2 px-2 text-[.8rem] opacity-75 text-nowrap italic">
																	<img
																		className="w-[1.15rem] cursor-pointer opacity-0 "
																		src={Cross}
																	/>
																	[Note]&nbsp;:&nbsp;{item.remarks}
																</div>
															)}
														</div>
														{(addonsToViewFromSelectedAddon[item.productId]
															?.length > 0 ||
															addonsToViewFromSelectedAddon[
															`${item.productId}_${haveVarient}`
															]) && (
																<div className="w-full flex flex-col gap-2 py-1 opacity-75 text-[.9rem]">
																	{(addonsToViewFromSelectedAddon[item.productId]
																		?.length > 0
																		? addonsToViewFromSelectedAddon[
																		item.productId
																		]
																		: addonsToViewFromSelectedAddon[
																		`${item.productId}_${haveVarient}`
																		]
																	).map((addon, addonIndex) => {
																		const total = addon.rate * addon.quantity;

																		return (
																			<div
																				key={addonIndex}
																				className="w-full flex justify-center items-center"
																			>
																				<div className="w-2/4 flex justify-start items-center px-2 gap-2">
																					<img
																						className="w-[1.15rem] opacity-50 cursor-pointer"
																						src={rMinus}
																						alt=""
																						onClick={() =>
																							removeAddon(
																								addon.productId,
																								addon.varientId,
																								addon.addonId
																							)
																						}
																					/>
																					{addon.addonName}
																				</div>
																				<div className="w-1/4 flex justify-center px-1">
																					<div className="flex px-2 justify-center items-center">
																						<div className="w-max flex justify-center items-center">
																							<img
																								className="w-[1rem] cursor-pointer"
																								src={left}
																								alt="?"
																								onClick={() =>
																									decrementAddon(
																										addon.productId,
																										addon.varientId,
																										addon.addonId
																									)
																								} // Adjust decrement logic
																							/>
																						</div>
																						<input
																							className="w-full border-none text-center bg-transparent"
																							type="number"
																							value={addon.quantity || 1}
																							onFocus={(e) =>
																								handleFocusQtyInputAddon(
																									e,
																									addon.productId,
																									addon.varientId,
																									addon.addonId
																								)
																							}
																							onBlur={(e) =>
																								handleBlurQtyInputAddon(
																									e,
																									addon.productId,
																									addon.varientId,
																									addon.addonId
																								)
																							}
																							onChange={(e) =>
																								handleOnChangeQtyInputAddon(
																									e,
																									addon.productId,
																									addon.varientId,
																									addon.addonId
																								)
																							}
																						/>
																						<div className="w-max flex justify-center items-center">
																							<img
																								className="w-[1rem] cursor-pointer transform scale-x-[-1]"
																								src={left}
																								alt="?"
																								onClick={() =>
																									incrementAddon(
																										addon.productId,
																										addon.varientId,
																										addon.addonId
																									)
																								} // Adjust increment logic
																							/>
																						</div>
																					</div>
																				</div>
																				<div className="w-1/4 flex justify-center">
																					{"\u20B9"} {total}
																				</div>
																			</div>
																		);
																	})}
																</div>
															)}
													</div>
												);
											})}

											{/* ......................................view previous orders................................................ */}

											{previewPreviousOrders && (
												<div className="absolute inset-0 bg-[#fff] z-[8888] flex flex-col gap-3 py-3 overflow-y-auto customScroll">
													{previousSelectedItems.length > 0 &&
														previousSelectedItems.map((kot, index) => {
															return (
																<div
																	className="w-full flex flex-col text-[1rem] bg-[#F5F5F5]"
																	key={index}
																>
																	<div className="w-full h-max flex bg-[#ccc] text-[.85rem] text-[#352d2d] px-2 py-1 font-semibold">
																		<div className="w-1/3 flex justify-start items-center">
																			KOT #{kot.kotNo}
																		</div>
																		<div className="w-1/3 flex justify-center items-center">
																			{kot.Time}
																		</div>
																		{/* <div className={`w-1/3 flex justify-end items-center italic ${kot.kotstatus === 1 ? 'text-[#c30000]' : 'opacity-75'}`}>{kot.kotstatus === 1 ? 'running kot' : 'served'}</div> */}
																	</div>
																	<div className="w-full flex flex-col px-2">
																		{kot.items.map((item, index) => {
																			const haveVarient =
																				item?.varientId || null;
																			const name = haveVarient
																				? `${item.productName} ${item.variantName || ""
																				}`
																				: item.productName;
																			const totalPrice =
																				item.quantity * item.rate;

																			return (
																				<div
																					className="w-full flex flex-col border-b"
																					key={index}
																				>
																					<div className="w-full flex flex-col">
																						<div className="w-full flex">
																							<div className="w-2/4 flex justify-start items-center py-1 gap-2">
																								<img
																									className="w-[1rem] opacity-75"
																									src={dot}
																									alt=" ? "
																								/>
																								<span>{name}</span>
																							</div>
																							<div className="w-1/4 flex justify-center items-center py-1">
																								<div className="flex p-1 justify-center items-center">
																									<input
																										className="w-full border-none text-center bg-transparent"
																										type="number"
																										disabled
																										value={item.quantity || 1}
																									/>
																								</div>
																							</div>
																							<div className="w-1/4 flex justify-center items-center py-1 font-semibold text-[.95rem]">
																								<img
																									className="Rupee"
																									src={Rupee}
																									alt="?"
																								/>
																								<span>{totalPrice}</span>
																							</div>
																						</div>
																						{item.remarks && (
																							<div className="w-full h-max flex justify-start items-center gap-2 mt-[-.25rem] pb-1 text-[.8rem] opacity-75 text-nowrap italic">
																								<img
																									className="w-[1rem] cursor-pointer opacity-0 "
																									src={Cross}
																								/>
																								[Note]&nbsp;:&nbsp;
																								{item.remarks}
																							</div>
																						)}
																					</div>
																					<div className="w-full flex flex-col text-[.875rem] opacity-75">
																						{item.addons.map((addon, index) => (
																							<div
																								key={index}
																								className="w-full flex"
																							>
																								<div className="w-2/4 flex justify-start items-center gap-2">
																									<img
																										className="w-[1rem] opacity-0"
																										src={dot}
																										alt=" ? "
																									/>
																									<span>{addon.addonName}</span>
																								</div>
																								<div className="w-1/4 flex justify-center items-center">
																									<div className="flex p-1 justify-center items-center">
																										<input
																											className="w-full border-none text-center bg-transparent"
																											type="number"
																											disabled
																											value={addon.qty || 1}
																										/>
																									</div>
																								</div>
																								<div className="w-1/4 flex justify-center items-center font-semibold text-[.87rem]">
																									<div className="flex justify-center items-center">
																										<img
																											className="w-[.8rem]"
																											src={Rupee}
																											alt="?"
																										/>
																									</div>
																									<span>{addon.rate}</span>
																								</div>
																							</div>
																						))}
																					</div>
																				</div>
																			);
																		})}
																	</div>
																	{/* <div className='w-full flex'>
                                                                    <div className='w-2/4 flex justify-start items-center p-1 px-2 gap-2'>
                                                                        <img
                                                                            className="w-[1rem] cursor-pointer"
                                                                            src={dot}
                                                                            alt=" ? "
                                                                        />
                                                                    </div>
                                                                    <div className='w-1/4 flex justify-center items-center p-1'>
                                                                        <div className='flex p-2 justify-center items-center'>
                                                                            <input 
                                                                            className='w-full border-none text-center bg-transparent'
                                                                            type="number" 
                                                                            disabled
                                                                            value={item.quantity || 1}/>
                                                                        </div>
                                                                    </div>
                                                                    <div className='w-1/4 flex justify-center items-center p-1 font-[600] text-[1.05rem]'>
                                                                        <img className="Rupee" src={Rupee} alt="?" />
                                                                    </div>
                                                                </div> */}
																	{/* {(previousSelectedAddons[item.productId]?.length > 0 || previousSelectedAddons[`${item.productId}_${haveVarient}`]) && (
                                                                    <div className='w-full flex flex-col gap-3 py-1 opacity-75'>
                                                                        {(previousSelectedAddons[item.productId]?.length > 0 ? 
                                                                        previousSelectedAddons[item.productId] : 
                                                                        previousSelectedAddons[`${item.productId}_${haveVarient}`]).map((addon, addonIndex) => {
                                                                            
                                                                            const total = addon.rate * addon.quantity

                                                                            return (
                                                                                <div 
                                                                                    key={addonIndex} 
                                                                                    className="w-full flex justify-center items-center"
                                                                                >
                                                                                    <div className="w-2/4 flex justify-start items-center px-2 gap-2">
                                                                                        <img className='w-[1rem] opacity-0 cursor-pointer' src={dot} alt="" />
                                                                                        {addon.addonName}
                                                                                    </div>
                                                                                    <div className="w-1/4 flex justify-center px-1">
                                                                                        <div className='flex px-2 justify-center items-center'>
                                                                                            <input 
                                                                                            className='w-full border-none text-center bg-transparent'
                                                                                            type="number" 
                                                                                            disabled
                                                                                            value={addon.quantity || 1}/>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="w-1/4 flex justify-center">{"\u20B9"} {total}</div>
                                                                                </div>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                )} */}
																</div>
															);
														})}
												</div>
											)}
										</div>
										<div
											className="h-max flex justify-center items-center absolute bg-[#465366] rounded-t-[.313rem] px-2 cursor-pointer"
											onClick={toggleVisibility}
										>
											<img className="w-[1rem] invert" src={Up} alt="?" />
										</div>
									</div>
								)}
								<div className="w-full h-max flex font-nunito bg-[#465366] text-[#fff] p-2">
									<div className="w-full flex justify-start items-center gap-1">
										<input
											type="checkbox"
											checked={isComplimentary}
											onChange={(e) => {
												if (!hasPermission('allowComplimentary')) {
													alert("You do not have permission to make bills complimentary!");
													return;
												}
												setIsComplimentary(e.target.checked);
											}}
										/>
										<span className="text-[.8rem]">Complimentary</span>
										<button
											className="bg-[#2591D1] px-2 py-1 rounded-sm text-[.75rem]"
											onClick={handleSplitBill}
										>
											Split Bill
										</button>
									</div>
									<div className="w-max flex justify-center items-center text-nowrap text-[1rem]">
										{/* {isVisible ? 'NetTotal: ' + totalValue : total } */}
										{isVisible ? (
											<span>{"NetTotal: " + totalValue}</span>
										) : (
											<div className="w-max flex justify-center items-center">
												<img className="invert w-[.95rem]" src={Rupee} alt="" />
												<span className="font-[500]">{total}</span>
											</div>
										)}
									</div>
								</div>
								<div className="w-full h-max flex justify-center items-center p-2 font-nunito cursor-default">
									{["cash", "card", "due", "other"].map((method) => (
										<div
											key={method}
											className={`CCDP_SelectedItems_KOT_CCDP_ ${paymentMethod ? "opacity-100" : "opacity-0"
												}`}
										>
											<input
												type="radio"
												name="group"
												className="cursor-pointer"
												defaultChecked={selectedPayment === method}
												onClick={() => handleCheckRadio(method)} // Use onClick
											/>
											{method.charAt(0).toUpperCase() + method.slice(1)}
										</div>
									))}
								</div>
								<div className="w-full h-max flex bg-[#465366] p-2"></div>
								<div className="w-full h-max flex justify-center items-center pt-2 font-nunito text-[.8rem] gap-2 font-[500] text-[#fff] text-nowrap text-center">
									<div
										className="bg-[#0008B4] rounded px-2 py-1 w-2/12 cursor-pointer"
										onClick={handleSaveKotAndBill}
									>
										Save
									</div>
									<div
										className="bg-[#0008B4] rounded px-2 py-1 w-3/12 cursor-pointer"
										onClick={handlePrintBill}
									>
										Print Bill
									</div>
									<div
										className="bg-[#0008B4] rounded px-2 py-1 w-2/12 cursor-pointer"
										onClick={handleSaveKOT}
									>
										KOT
									</div>
									{/* <div className='bg-[#0008B4] rounded px-2 py-1 w-2/12 cursor-pointer' onClick={handlePrintBpos}>bpos</div> */}
									<div
										className="bg-[#0008B4] rounded px-2 py-1 w-3/12 cursor-pointer"
										onClick={handleKotAndPrint}
									>
										KOT & Print
									</div>
									<div
										className="bg-[#0008B4] rounded px-2 py-1 w-2/12 cursor-pointer"
										onClick={() => {
											if (billNo) {
												alert("Running order!");
											} else {
												handleHoldLoadOrderFunc("hold");
											}
										}}
									>
										Hold
									</div>
								</div>
							</div>
							{selectCount && (
								<div className="absolute inset-0 w-full h-full flex justify-center items-center z-[8888] bg-[#000] bg-opacity-75 overflow-hidden">
									<VariantCountKOT
										id={toVariantCountKot}
										savedCount={variantCountSaved}
										selectedItems={selectedItems}
										remainingStock={getRemainingStock(toVariantCountKot?.id_productReg)}
										productionMap={productionMap}
										prodSettings={prodSettings}
										products={products}
										onClose={(state) => setSelectCount(state)} // Directly set `selectCount`
										onSave={(
											countsVKOT,
											selectedVariant,
											proIdVKOT,
											selectedAddon,
											remarks
										) => {
											handleSaveInParent(
												countsVKOT,
												selectedVariant,
												proIdVKOT,
												selectedAddon,
												remarks
											);
											setSelectCount(false);
										}} // Add your handler
									/>
								</div>
							)}

							{part && (
								<PartPay
									onClose={(state) => setPart(state)}
									billNo={billNo}
									amount={prevOrderTotal}
									prevPayments={payments}
									customerPhone={customerDetails.mobile}
									updated={(data) => setPayments(data)}
									setSelectedPaymentFunc={(pay, state) => {
										setSelectedPayment(pay);
										setShowPaymentInfo(state);
									}}
								/>
							)}

							{/* {splitTableState && (
								<div className="absolute inset-0 bg-black bg-opacity-75 p-20 flex justify-center items-center">
									<div className="w-full h-full flex flex-col bg-[#fff] rounded p-2">
										splitTableState
									</div>
								</div>
							)} */}

							{mergeTableState && (
								<div className="absolute inset-0 bg-black bg-opacity-75 p-20 flex justify-center items-center z-10">
									<div className="w-full h-full flex flex-col bg-[#fff] rounded p-2 overflow-hidden">
										<div className="w-full h-max flex p-2">
											<div className="flex text-left w-full">
												<span className="font-[700]">Merge Tables</span>
											</div>
											<div className="flex justify-end items-start w-max">
												<img
													className="w-[1rem] cursor-pointer"
													src={close}
													alt=""
													onClick={() => {
														setMergeTableState(false);
														handleResetMerging();
														setSelectedTables(selectedTableForMerge);
														setCheckedTable(
															meragableTables.map((table) =>
																selectedTableForMerge.includes(table.Table_id)
															)
														);
														const allSelected = meragableTables.every((table) =>
															selectedTableForMerge.includes(table.Table_id)
														);
														setIsCheckedAll(allSelected);
													}}
												/>
											</div>
										</div>
										<div className="w-full h-full flex flex-col pl-2 pb-2 pr-2 gap-1 text-center overflow-auto customScroll bg-[#fff]">
											<div className="flex w-full gap-1 font-[700] sticky top-0 bg-[#fff] pt-2">
												<div className="w-1/12 p-3 bg-[#c6c6c6] flex justify-center items-center">
													<input
														type="checkbox"
														checked={isCheckedAll}
														onChange={(e) => handleIsCheckedAll(e)}
													/>
												</div>
												<div className="w-5/12 bg-[#c6c6c6] px-3 py-2 flex justify-start items-center">
													Table
												</div>
												<div className="w-3/12 bg-[#c6c6c6] p-2 flex justify-center items-center">
													Capacity
												</div>
												<div className="w-3/12 bg-[#c6c6c6] p-2 flex justify-center items-center">
													Action
												</div>
											</div>
											<div className="w-full flex flex-col gap-1">
												{meragableTables.map((table, index) => (
													<div className="flex w-full gap-1" key={index}>
														<div className="w-1/12 p-3 flex justify-center items-center bg-[#f7f7f7]">
															<input
																type="checkbox"
																checked={checkedTable[index]}
																onChange={(e) =>
																	handleIsChecked(index, e.target.checked)
																}
															/>
														</div>
														<div className="w-5/12 flex justify-start items-center bg-[#f7f7f7] px-3 py-2 gap-2">
															<div className="flex justify-center items-center">
																<img
																	className="w-[1.25rem]"
																	src={Roundtable}
																	alt=""
																/>
															</div>
															<span>{table.Table_onlineName}</span>
														</div>
														<div className="w-3/12 bg-[#f7f7f7] p-2 text-center">
															{table.Table_Capacity}
														</div>
														<div className="w-3/12 flex justify-center items-center bg-[#fff] gap-1">
															<div
																className={`w-full h-full flex justify-center items-center p-2 ${selectedTables.length > 0 &&
																	checkedTable[index]
																	? "bg-[#0008B4] bg-opacity-25 text-[#0008B4] cursor-pointer"
																	: selectedTables.length === 0
																		? "bg-[#0008B4] bg-opacity-25 text-[#0008B4] cursor-pointer"
																		: "bg-[#f7f7f7] text-[#666666]"
																	}`}
																// disabled={selectedTables.length > 0 && checkedTable[index]}
																onClick={() => {
																	if (selectedTables.length > 0) {
																		if (checkedTable[index]) {
																			handleMergeTable(
																				index,
																				table.Table_id,
																				table.Table_onlineName,
																				table.Table_Capacity
																			);
																		}
																	} else {
																		handleMergeTable(
																			index,
																			table.Table_id,
																			table.Table_onlineName,
																			table.Table_Capacity
																		);
																	}
																}}
															>
																<span className="font-[600] font-nunito">
																	Merge
																</span>
															</div>
														</div>
													</div>
												))}
											</div>
										</div>
										{selectedTableForMerge.length > 0 && (
											<div className="w-full h-max flex justify-end items-center p-2">
												<button
													className="bg-[#0008B4] px-3 py-1 rounded-sm text-[#fff]"
													onClick={handleOnReset}
												>
													Reset
												</button>
											</div>
										)}
									</div>
									{nameForMergedTable && (
										<div
											className="absolute inset-0 w-full h-full bg-black bg-opacity-50 p-10 flex justify-center items-center"
											onClick={(e) => {
												setNameForMergedTable(false);
												e.stopPropagation();
												setTotalPersons_();
												setSelectedTables(selectedTableForMerge);
												setCheckedTable(
													meragableTables.map((table) =>
														selectedTableForMerge.includes(table.Table_id)
													)
												);
												const allSelected = meragableTables.every((table) =>
													selectedTableForMerge.includes(table.Table_id)
												);
												setIsCheckedAll(allSelected);
											}}
										>
											<div
												className="w-[30rem] text-nowrap flex justify-center items-center bg-[#fff] p-3 gap-3 rounded"
												onClick={(e) => e.stopPropagation()}
											>
												<span>Table Name:</span>
												<div className="w-full flex areaBorder rounded-sm">
													<input
														type="text"
														className="w-full p-1 border-0"
														onChange={handleOnChangeTableName}
													/>
													<div className="w-max flex justify-center items-center p-2">
														{avail == 1 && (
															<img className="w-[1.25rem]" src={tick} alt="" />
														)}
														{avail == 0 && (
															<img className="w-[1.25rem]" src={cross} alt="" />
														)}
													</div>
												</div>
												<button
													className="w-max bg-[#0008B4] px-3 py-1 rounded-sm text-[#fff]"
													onClick={handleSaveMerging}
												>
													Save
												</button>
											</div>
										</div>
									)}
								</div>
							)}

							<SplitBillModal
								isOpen={splitBillState}
								onClose={() => setSplitBillState(false)}
								originalBillNo={billNo}
								tableno={tableNo_}
								areaId={area_id_}
								tableType={table_}
								previousOrders={previousOrders}
								userType={userType}
								apiBaseUrl={api_base_url}
								logginedDB={logginedDB}
								genSettings={genSettings}
								taxGroups={taxGroups}
								onSuccess={(newBillNos) => {
									setSplitBillState(false);
									navigate("/TableView");
								}}
							/>

							{holdLoad && holdLoad === "load" && (
								<div className="absolute inset-0 bg-black bg-opacity-75 p-20 flex justify-center items-center">
									<div className="w-full h-full flex flex-col bg-[#fff] rounded p-2">
										<div className="w-full h-max flex p-2">
											<div className="flex text-left w-full">
												<span className="font-[700]">Holding Orders</span>
											</div>
											<div className="flex justify-end items-start w-max">
												<img
													className="w-[1rem] cursor-pointer"
													src={close}
													alt=""
													onClick={() => {
														setHoldLoadOrderFunc(null);
													}}
												/>
											</div>
										</div>
										<div className="w-full h-full flex flex-col pl-2 pb-2 pr-2 gap-1 text-center overflow-auto customScroll bg-[#fff]">
											<div className="flex w-full gap-1 font-[700] sticky top-0 bg-[#fff] pt-2">
												<div className="w-1/12 bg-[#c6c6c6] p-2">SI</div>
												<div className="w-2/12 bg-[#c6c6c6] p-2 text-left">
													Date
												</div>
												<div className="w-3/12 bg-[#c6c6c6] p-2 text-left">
													Name
												</div>
												<div className="w-2/12 bg-[#c6c6c6] p-2">Phone</div>
												<div className="w-2/12 bg-[#c6c6c6] p-2">Address</div>
												<div className="w-2/12 bg-[#c6c6c6] p-2">Action</div>
											</div>
											<div className="w-full flex flex-col gap-1">
												{holdInformations.map((hold, index) => (
													<div className="flex w-full gap-1" key={index}>
														<div className="w-1/12 bg-[#f7f7f7] p-2">
															{index + 1}
														</div>
														<div className="w-2/12 bg-[#f7f7f7] p-2">
															{hold.Date}
														</div>
														<div className="w-3/12 bg-[#f7f7f7] p-2 text-left">
															{hold.partyname}
														</div>
														<div className="w-2/12 bg-[#f7f7f7] p-2">
															{hold.mob}
														</div>
														<div className="w-2/12 bg-[#f7f7f7] p-2">
															{hold.PAdd1}
														</div>
														<div className="w-2/12 flex justify-center items-center bg-[#fff] gap-1">
															{/* <div className='w-1/2 h-full bg-[#c30000] bg-opacity-25 flex justify-center items-center p-2 cursor-pointer' onClick={() => handleRemoveOrders(hold.HoldNo)}>
                                                                    <img className='w-[1rem]' src={remove} alt="" />
                                                                </div> */}
															<div
																className="w-full h-full bg-[#0008B4] bg-opacity-25 flex justify-center items-center p-2 cursor-pointer"
																onClick={() => handleLoadOrders(hold.HoldNo)}
															>
																{/* <img className='w-[1.1rem]' src={loadIt} alt="" /> */}
																<span className="text-[#0008B4] font-[600] font-nunito">
																	Load
																</span>
															</div>
														</div>
													</div>
												))}
											</div>
										</div>
									</div>
								</div>
							)}
							{holdLoad && holdLoad === "hold" && (
								<div className="absolute inset-0 bg-black bg-opacity-75 p-20 flex justify-center items-center overflow-hidden">
									<div className="w-full h-full flex flex-col bg-[#fff] rounded p-2 overflow-hidden">
										<div className="w-full h-max flex p-2">
											<div className="flex text-left w-full">
												<span className="font-[700]">Information</span>
											</div>
											<div className="flex justify-end items-start w-max">
												<img
													className="w-[1rem] cursor-pointer"
													src={close}
													alt=""
													onClick={() => {
														setHoldLoadOrderFunc(null);
													}}
												/>
											</div>
										</div>
										<div className="w-full h-full flex flex-col p-2 font-nunito font-[500] text-[1rem] gap-2 text-left overflow-auto customScroll bg-[#fff]">
											<div className="w-full h-max flex gap-3">
												<div className="w-1/2 flex flex-col gap-1">
													<span>Party Name</span>
													<input
														className="px-2 py-[.4rem]"
														type="text"
														value={holdInfo.partyName}
														onChange={(e) => handleOnChangeInfo(e, "partyName")}
													/>
												</div>
												<div className="w-1/2 h-max flex flex-col gap-1">
													<span>Mobile No.</span>
													<input
														className="px-2 py-[.4rem]"
														type="number"
														value={holdInfo.mob}
														onChange={(e) => handleOnChangeInfo(e, "mob")}
													/>
												</div>
											</div>
											<div className="w-full flex gap-3">
												<div className="w-1/2 h-max flex flex-col gap-1">
													<span>Address 1</span>
													<input
														className="px-2 py-[.4rem]"
														type="text"
														value={holdInfo.add1}
														onChange={(e) => handleOnChangeInfo(e, "add1")}
													/>
												</div>
												<div className="w-1/2 h-max flex flex-col gap-1">
													<span>Address 2</span>
													<input
														className="px-2 py-[.4rem]"
														type="text"
														value={holdInfo.add2}
														onChange={(e) => handleOnChangeInfo(e, "add2")}
													/>
												</div>
											</div>
											<div className="w-full h-full flex flex-col gap-1">
												<span>Note</span>
												<textarea
													className="h-full px-2 py-[.4rem] border rounded-[.313rem] w-full focus:outline-none customScroll"
													type="text"
													value={holdInfo.note}
													onChange={(e) => handleOnChangeInfo(e, "note")}
												/>
											</div>
										</div>
										<div className="w-full h-max flex p-2 justify-end items-center gap-2">
											<button
												className="pl-4 pr-4 pt-1 pb-1 loginBorder text-[#0008B4] rounded-[.313rem]"
												onClick={() => {
													setHoldLoadOrderFunc(null);
												}}
											>
												Cancel
											</button>
											<button
												className="pl-4 pr-4 pt-1 pb-1 bg-[#0008B4] loginBorder text-[#fff] rounded-[.313rem]"
												onClick={handleHoldOrders}
											>
												Hold
											</button>
										</div>
									</div>
								</div>
							)}

							{printBill && (
								<div className="w-full h-full absolute inset-0 bg-black bg-opacity-75 fontSizeClass p-10 flex justify-center items-center overflow-hidden">
									<PrintBill
										onClose={(state) => setPrintBill(state)}
										tableNo={kotTableNo}
										area_id={kotAreaId}
										table={kotTableType}
										billNo={billNo}
										previousSelectedItems={currentPrintItems}
										toIncludeAddonsToPrint={currentPrintAddons}
										total={isBillAmountAdded ? addedBillTotal : total}
										billAdjustments={isBillAmountAdded ? addedBillAdjustments : null}
										orderToKot={orderToKot}
										genSettings={genSettings}
										taxGroups={taxGroups}
										customerName={customerDetails?.name || ""}
										customerPhone={customerDetails?.mobile || ""}
										customerAddress={customerDetails?.addr || ""}
										orderType={for_}
									/>
								</div>
							)}

						</div>
					</div>
				</div>
			</div>

			{/* ................................................MObile View........................................... */}

		</div>
	);
}

export default KOT;
